module.exports = {
	"words": {
		"she": {
			"freq": 134,
			"words": {
				"couldn't": {
					"freq": 2,
					"words": {
						"convince": {
							"freq": 1
						}
					}
				},
				"advised": {
					"freq": 6,
					"words": {
						"him": {
							"freq": 3
						}
					}
				},
				"was": {
					"freq": 10,
					"words": {
						"making": {
							"freq": 1
						},
						"very": {
							"freq": 1
						},
						"aching": {
							"freq": 1
						},
						"injured": {
							"freq": 1
						},
						"advised": {
							"freq": 1
						}
					}
				},
				"fell": {
					"freq": 2,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"acted": {
					"freq": 4,
					"words": {
						"like": {
							"freq": 1
						},
						"as": {
							"freq": 1
						}
					}
				},
				"went": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 7,
					"words": {
						"on": {
							"freq": 1
						},
						"in": {
							"freq": 1
						},
						"cooking": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"still": {
					"freq": 2,
					"words": {
						"loves": {
							"freq": 1
						}
					}
				},
				"stabbed": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"had": {
					"freq": 4,
					"words": {
						"no": {
							"freq": 1
						},
						"nothing": {
							"freq": 1
						}
					}
				},
				"stole": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"heard": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"watched": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"forced": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"sat": {
					"freq": 2,
					"words": {
						"next": {
							"freq": 1
						}
					}
				},
				"were": {
					"freq": 1,
					"words": {
						"somewhere": {
							"freq": 1
						}
					}
				},
				"can": {
					"freq": 2,
					"words": {
						"speak": {
							"freq": 1
						}
					}
				},
				"cooks": {
					"freq": 2,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"has": {
					"freq": 2,
					"words": {
						"about": {
							"freq": 1
						}
					}
				},
				"looks": {
					"freq": 2,
					"words": {
						"happy": {
							"freq": 1
						}
					}
				},
				"stared": {
					"freq": 2,
					"words": {
						"at": {
							"freq": 1
						}
					}
				},
				"introduced": {
					"freq": 2,
					"words": {
						"her": {
							"freq": 1
						}
					}
				},
				"crouched": {
					"freq": 2,
					"words": {
						"down": {
							"freq": 1
						}
					}
				},
				"got": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"kicked": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"asked": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"hates": {
					"freq": 2,
					"words": {
						"fish": {
							"freq": 1
						}
					}
				},
				"endure": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"intended": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"didn't": {
					"freq": 1,
					"words": {
						"care": {
							"freq": 1
						}
					}
				},
				"feeds": {
					"freq": 2,
					"words": {
						"her": {
							"freq": 1
						}
					}
				},
				"took": {
					"freq": 4,
					"words": {
						"care": {
							"freq": 1
						},
						"him": {
							"freq": 1
						}
					}
				},
				"boiled": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"helped": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"raced": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"repulses": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"couldn't": {
			"freq": 1,
			"words": {
				"convince": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"convince": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"him": {
			"freq": 20,
			"words": {
				"to": {
					"freq": 7,
					"words": {
						"give": {
							"freq": 2
						},
						"become": {
							"freq": 1
						},
						"do": {
							"freq": 1
						},
						"repair": {
							"freq": 1
						},
						"cut": {
							"freq": 1
						},
						"the": {
							"freq": 1
						}
					}
				},
				"out": {
					"freq": 1,
					"words": {
						"again": {
							"freq": 1
						}
					}
				},
				"from": {
					"freq": 1,
					"words": {
						"being": {
							"freq": 1
						}
					}
				},
				"about": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				},
				"wishing": {
					"freq": 1,
					"words": {
						"she": {
							"freq": 1
						}
					}
				},
				"every": {
					"freq": 1,
					"words": {
						"now": {
							"freq": 1
						}
					}
				},
				"in": {
					"freq": 1
				},
				"even": {
					"freq": 1,
					"words": {
						"though": {
							"freq": 1
						}
					}
				},
				"save": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				},
				"where": {
					"freq": 1,
					"words": {
						"jessie": {
							"freq": 1
						}
					}
				},
				"against": {
					"freq": 1,
					"words": {
						"doing": {
							"freq": 1
						}
					}
				},
				"tie": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				},
				"down": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"to": {
			"freq": 79,
			"words": {
				"give": {
					"freq": 3,
					"words": {
						"a": {
							"freq": 1
						},
						"up": {
							"freq": 2
						}
					}
				},
				"get": {
					"freq": 5,
					"words": {
						"my": {
							"freq": 1
						},
						"there": {
							"freq": 1
						},
						"along": {
							"freq": 1
						},
						"a": {
							"freq": 2
						}
					}
				},
				"become": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"know": {
					"freq": 1,
					"words": {
						"why": {
							"freq": 1
						}
					}
				},
				"some": {
					"freq": 1,
					"words": {
						"extent": {
							"freq": 1
						}
					}
				},
				"see": {
					"freq": 3,
					"words": {
						"me": {
							"freq": 1
						},
						"him": {
							"freq": 1
						},
						"them": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 6,
					"words": {
						"station": {
							"freq": 3
						},
						"radio": {
							"freq": 1
						},
						"second": {
							"freq": 1
						},
						"zoo": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						},
						"my": {
							"freq": 1
						}
					}
				},
				"translate": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"do": {
					"freq": 4,
					"words": {
						"the": {
							"freq": 1
						},
						"it": {
							"freq": 1
						},
						"yesterday": {
							"freq": 1
						},
						"things": {
							"freq": 1
						}
					}
				},
				"wait": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 3,
					"words": {
						"unpleasant": {
							"freq": 1
						},
						"fast": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"talk": {
					"freq": 1,
					"words": {
						"about": {
							"freq": 1
						}
					}
				},
				"having": {
					"freq": 1,
					"words": {
						"dinner": {
							"freq": 1
						}
					}
				},
				"call": {
					"freq": 2,
					"words": {
						"my": {
							"freq": 1
						},
						"it": {
							"freq": 1
						}
					}
				},
				"tell": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"drunken": {
					"freq": 1,
					"words": {
						"driving": {
							"freq": 1
						}
					}
				},
				"send": {
					"freq": 2,
					"words": {
						"postcards": {
							"freq": 1
						},
						"it": {
							"freq": 1
						}
					}
				},
				"expect": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"stay": {
					"freq": 1,
					"words": {
						"long": {
							"freq": 1
						}
					}
				},
				"rain": {
					"freq": 1,
					"words": {
						"soon": {
							"freq": 1
						}
					}
				},
				"work": {
					"freq": 1,
					"words": {
						"until": {
							"freq": 1
						}
					}
				},
				"interrupt": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"accept": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"san": {
					"freq": 1
				},
				"go": {
					"freq": 3,
					"words": {
						"unless": {
							"freq": 1
						},
						"shopping": {
							"freq": 1
						},
						"to": {
							"freq": 1
						}
					}
				},
				"study": {
					"freq": 1,
					"words": {
						"harder": {
							"freq": 1
						}
					}
				},
				"come": {
					"freq": 1,
					"words": {
						"with": {
							"freq": 1
						}
					}
				},
				"walk": {
					"freq": 2,
					"words": {
						"all": {
							"freq": 1
						},
						"away": {
							"freq": 1
						}
					}
				},
				"any": {
					"freq": 1,
					"words": {
						"party": {
							"freq": 1
						}
					}
				},
				"pick": {
					"freq": 1,
					"words": {
						"them": {
							"freq": 1
						}
					}
				},
				"postpone": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				},
				"write": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"leave": {
					"freq": 1,
					"words": {
						"today": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"mountain": {
					"freq": 1,
					"words": {
						"climbing": {
							"freq": 1
						}
					}
				},
				"attend": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"prepare": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"repair": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				},
				"nancy": {
					"freq": 1,
					"words": {
						"next": {
							"freq": 1
						}
					}
				},
				"bed": {
					"freq": 2,
					"words": {
						"at": {
							"freq": 2
						}
					}
				},
				"help": {
					"freq": 1,
					"words": {
						"clean": {
							"freq": 1
						}
					}
				},
				"eat": {
					"freq": 1,
					"words": {
						"dog": {
							"freq": 1
						}
					}
				},
				"upload": {
					"freq": 1,
					"words": {
						"an": {
							"freq": 1
						}
					}
				},
				"catch": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"clear": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"running": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"cut": {
					"freq": 1,
					"words": {
						"down": {
							"freq": 1
						}
					}
				},
				"invite": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"birthday": {
							"freq": 1
						}
					}
				},
				"play": {
					"freq": 1,
					"words": {
						"poker": {
							"freq": 1
						}
					}
				},
				"consult": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"give": {
			"freq": 9,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"speech": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 3,
					"words": {
						"just": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 3,
					"words": {
						"smoking": {
							"freq": 1
						},
						"city": {
							"freq": 1
						},
						"drinking": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"where": {
			"freq": 13,
			"words": {
				"did": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 2,
					"words": {
						"room": {
							"freq": 1
						}
					}
				},
				"does": {
					"freq": 2,
					"words": {
						"she": {
							"freq": 1
						}
					}
				},
				"are": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"jessie": {
					"freq": 1,
					"words": {
						"was": {
							"freq": 1
						}
					}
				}
			}
		},
		"did": {
			"freq": 23,
			"words": {
				"you": {
					"freq": 16,
					"words": {
						"learn": {
							"freq": 1
						},
						"invite": {
							"freq": 1
						},
						"accomplish": {
							"freq": 1
						},
						"do": {
							"freq": 1
						},
						"finish": {
							"freq": 1
						},
						"hear": {
							"freq": 1
						},
						"study": {
							"freq": 1
						},
						"go": {
							"freq": 1
						},
						"enjoy": {
							"freq": 1
						},
						"say": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1,
					"words": {
						"sort": {
							"freq": 1
						}
					}
				}
			}
		},
		"do": {
			"freq": 29,
			"words": {
				"you": {
					"freq": 20,
					"words": {
						"have": {
							"freq": 2
						},
						"get": {
							"freq": 2
						},
						"know": {
							"freq": 1
						},
						"study": {
							"freq": 1
						},
						"think": {
							"freq": 2
						},
						"want": {
							"freq": 2
						},
						"need": {
							"freq": 1
						},
						"spend": {
							"freq": 1
						},
						"usually": {
							"freq": 1
						},
						"remember": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"job": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"things": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"you": {
			"freq": 85,
			"words": {
				"have": {
					"freq": 4,
					"words": {
						"anything": {
							"freq": 1
						},
						"to": {
							"freq": 1
						}
					}
				},
				"invite": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"don't": {
					"freq": 6,
					"words": {
						"get": {
							"freq": 1
						},
						"have": {
							"freq": 1
						},
						"need": {
							"freq": 1
						}
					}
				},
				"swim": {
					"freq": 1,
					"words": {
						"underwater": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 2,
					"words": {
						"some": {
							"freq": 1
						},
						"invite": {
							"freq": 1
						}
					}
				},
				"accomplish": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"said": {
					"freq": 1,
					"words": {
						"laura": {
							"freq": 1
						}
					}
				},
				"allergic": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"love": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"sure": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"should": {
					"freq": 4,
					"words": {
						"give": {
							"freq": 1
						},
						"have": {
							"freq": 1
						}
					}
				},
				"do": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"given": {
					"freq": 1,
					"words": {
						"any": {
							"freq": 1
						}
					}
				},
				"like": {
					"freq": 2,
					"words": {
						"some": {
							"freq": 1
						},
						"to": {
							"freq": 1
						}
					}
				},
				"mind": {
					"freq": 1,
					"words": {
						"if": {
							"freq": 1
						}
					}
				},
				"get": {
					"freq": 2,
					"words": {
						"up": {
							"freq": 1
						},
						"along": {
							"freq": 1
						}
					}
				},
				"speak": {
					"freq": 3,
					"words": {
						"french": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"ages": {
							"freq": 1
						}
					}
				},
				"going": {
					"freq": 3,
					"words": {
						"to": {
							"freq": 3
						}
					}
				},
				"know": {
					"freq": 1,
					"words": {
						"who": {
							"freq": 1
						}
					}
				},
				"just": {
					"freq": 1,
					"words": {
						"walk": {
							"freq": 1
						}
					}
				},
				"while": {
					"freq": 1
				},
				"think": {
					"freq": 2,
					"words": {
						"that's": {
							"freq": 1
						}
					}
				},
				"took": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"write": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				},
				"want": {
					"freq": 4,
					"words": {
						"to": {
							"freq": 3
						},
						"me": {
							"freq": 1
						}
					}
				},
				"must": {
					"freq": 2,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"finish": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"hear": {
					"freq": 2,
					"words": {
						"my": {
							"freq": 1
						},
						"me": {
							"freq": 1
						}
					}
				},
				"study": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				},
				"go": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"didn't": {
					"freq": 1,
					"words": {
						"call": {
							"freq": 1
						}
					}
				},
				"enjoy": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"tell": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"give": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"need": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				},
				"come": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"put": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				},
				"spend": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				},
				"please": {
					"freq": 2,
					"words": {
						"shut": {
							"freq": 1
						},
						"lend": {
							"freq": 1
						}
					}
				},
				"told": {
					"freq": 1,
					"words": {
						"anyone": {
							"freq": 1
						}
					}
				},
				"usually": {
					"freq": 1,
					"words": {
						"decide": {
							"freq": 1
						}
					}
				},
				"so": {
					"freq": 1,
					"words": {
						"much": {
							"freq": 1
						}
					}
				},
				"broke": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"remember": {
					"freq": 1,
					"words": {
						"how": {
							"freq": 1
						}
					}
				},
				"look": {
					"freq": 1,
					"words": {
						"after": {
							"freq": 1
						}
					}
				}
			}
		},
		"have": {
			"freq": 30,
			"words": {
				"a": {
					"freq": 4,
					"words": {
						"bite": {
							"freq": 1
						},
						"glass": {
							"freq": 1
						},
						"hard": {
							"freq": 1
						},
						"lot": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"car": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 7,
					"words": {
						"wait": {
							"freq": 1
						},
						"call": {
							"freq": 1
						},
						"expect": {
							"freq": 1
						},
						"go": {
							"freq": 1
						},
						"come": {
							"freq": 1
						},
						"write": {
							"freq": 1
						},
						"do": {
							"freq": 1
						}
					}
				},
				"anything": {
					"freq": 1,
					"words": {
						"cheaper": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 4,
					"words": {
						"given": {
							"freq": 1
						},
						"told": {
							"freq": 1
						}
					}
				},
				"known": {
					"freq": 2,
					"words": {
						"each": {
							"freq": 1
						},
						"what": {
							"freq": 1
						}
					}
				},
				"left": {
					"freq": 2,
					"words": {
						"half": {
							"freq": 1
						},
						"it": {
							"freq": 1
						}
					}
				},
				"made": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"bottled": {
					"freq": 1,
					"words": {
						"water": {
							"freq": 1
						}
					}
				},
				"put": {
					"freq": 1,
					"words": {
						"off": {
							"freq": 1
						}
					}
				},
				"been": {
					"freq": 2,
					"words": {
						"busy": {
							"freq": 1
						},
						"married": {
							"freq": 1
						}
					}
				},
				"trouble": {
					"freq": 1,
					"words": {
						"getting": {
							"freq": 1
						}
					}
				}
			}
		},
		"smile": {
			"freq": 3,
			"words": {
				"at": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"at": {
			"freq": 7,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"camera": {
							"freq": 1
						}
					}
				},
				"least": {
					"freq": 1,
					"words": {
						"two": {
							"freq": 1
						}
					}
				},
				"home": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"him": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 1,
					"words": {
						"everyone": {
							"freq": 1
						}
					}
				},
				"first": {
					"freq": 1,
					"words": {
						"sight": {
							"freq": 1
						}
					}
				},
				"about": {
					"freq": 1,
					"words": {
						"11:00": {
							"freq": 1
						}
					}
				}
			}
		},
		"the": {
			"freq": 74,
			"words": {
				"camera": {
					"freq": 1
				},
				"boss": {
					"freq": 2,
					"words": {
						"just": {
							"freq": 1
						}
					}
				},
				"ice": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"station": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"right": {
					"freq": 1,
					"words": {
						"number": {
							"freq": 1
						}
					}
				},
				"poem": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				},
				"man": {
					"freq": 2,
					"words": {
						"robbed": {
							"freq": 1
						}
					}
				},
				"curtain": {
					"freq": 2,
					"words": {
						"fell": {
							"freq": 1
						}
					}
				},
				"castle": {
					"freq": 2,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"audience": {
					"freq": 2,
					"words": {
						"was": {
							"freq": 1
						}
					}
				},
				"last": {
					"freq": 3,
					"words": {
						"time": {
							"freq": 1
						},
						"train": {
							"freq": 1
						},
						"minute": {
							"freq": 1
						}
					}
				},
				"door": {
					"freq": 1,
					"words": {
						"without": {
							"freq": 1
						}
					}
				},
				"baby": {
					"freq": 4,
					"words": {
						"seemed": {
							"freq": 1
						},
						"is": {
							"freq": 1
						}
					}
				},
				"faintest": {
					"freq": 1,
					"words": {
						"idea": {
							"freq": 1
						}
					}
				},
				"hall": {
					"freq": 1,
					"words": {
						"closet": {
							"freq": 1
						}
					}
				},
				"accident": {
					"freq": 1,
					"words": {
						"happened": {
							"freq": 1
						}
					}
				},
				"way": {
					"freq": 2,
					"words": {
						"home": {
							"freq": 1
						},
						"to": {
							"freq": 1
						}
					}
				},
				"money": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"alarm": {
					"freq": 2,
					"words": {
						"went": {
							"freq": 1
						}
					}
				},
				"ticket": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"least": {
					"freq": 1,
					"words": {
						"money": {
							"freq": 1
						}
					}
				},
				"letter": {
					"freq": 1,
					"words": {
						"today": {
							"freq": 1
						}
					}
				},
				"file": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"decision": {
					"freq": 2,
					"words": {
						"was": {
							"freq": 1
						}
					}
				},
				"more": {
					"freq": 2,
					"words": {
						"time": {
							"freq": 1
						}
					}
				},
				"less": {
					"freq": 1,
					"words": {
						"time": {
							"freq": 1
						}
					}
				},
				"odds": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"traffic": {
					"freq": 1,
					"words": {
						"accident": {
							"freq": 1
						}
					}
				},
				"high": {
					"freq": 1,
					"words": {
						"school": {
							"freq": 1
						}
					}
				},
				"train": {
					"freq": 2,
					"words": {
						"arrived": {
							"freq": 1
						}
					}
				},
				"prime": {
					"freq": 2,
					"words": {
						"minister": {
							"freq": 1
						}
					}
				},
				"passengers": {
					"freq": 1,
					"words": {
						"were": {
							"freq": 1
						}
					}
				},
				"heavy": {
					"freq": 1,
					"words": {
						"bag": {
							"freq": 1
						}
					}
				},
				"surprise": {
					"freq": 1,
					"words": {
						"party": {
							"freq": 1
						}
					}
				},
				"same": {
					"freq": 1,
					"words": {
						"kind": {
							"freq": 1
						}
					}
				},
				"second": {
					"freq": 1,
					"words": {
						"floor": {
							"freq": 1
						}
					}
				},
				"doctor": {
					"freq": 2,
					"words": {
						"advised": {
							"freq": 1
						}
					}
				},
				"new": {
					"freq": 1,
					"words": {
						"student": {
							"freq": 1
						}
					}
				},
				"concert": {
					"freq": 2,
					"words": {
						"was": {
							"freq": 1
						}
					}
				},
				"teacher": {
					"freq": 1,
					"words": {
						"finished": {
							"freq": 1
						}
					}
				},
				"beer": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"place": {
					"freq": 1,
					"words": {
						"while": {
							"freq": 1
						}
					}
				}
			}
		},
		"i": {
			"freq": 224,
			"words": {
				"think": {
					"freq": 16,
					"words": {
						"it's": {
							"freq": 6
						},
						"i": {
							"freq": 1
						},
						"he": {
							"freq": 1
						}
					}
				},
				"don't": {
					"freq": 21,
					"words": {
						"like": {
							"freq": 3
						},
						"care": {
							"freq": 2
						},
						"understand": {
							"freq": 2
						},
						"feel": {
							"freq": 2
						},
						"know": {
							"freq": 2
						}
					}
				},
				"agree": {
					"freq": 2,
					"words": {
						"with": {
							"freq": 1
						}
					}
				},
				"ate": {
					"freq": 2,
					"words": {
						"already": {
							"freq": 1
						}
					}
				},
				"thought": {
					"freq": 3,
					"words": {
						"you": {
							"freq": 1
						},
						"doing": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 1,
					"words": {
						"feeding": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 8,
					"words": {
						"to": {
							"freq": 3
						},
						"a": {
							"freq": 2
						},
						"been": {
							"freq": 1
						}
					}
				},
				"know": {
					"freq": 2,
					"words": {
						"it's": {
							"freq": 1
						}
					}
				},
				"expect": {
					"freq": 2,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"borrow": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"want": {
					"freq": 6,
					"words": {
						"to": {
							"freq": 2
						},
						"something": {
							"freq": 1
						}
					}
				},
				"haven't": {
					"freq": 4,
					"words": {
						"seen": {
							"freq": 1
						},
						"the": {
							"freq": 1
						}
					}
				},
				"fell": {
					"freq": 4,
					"words": {
						"asleep": {
							"freq": 2
						}
					}
				},
				"take": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"came": {
					"freq": 2,
					"words": {
						"here": {
							"freq": 1
						}
					}
				},
				"had": {
					"freq": 8,
					"words": {
						"no": {
							"freq": 1
						},
						"to": {
							"freq": 2
						},
						"my": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"heard": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"like": {
					"freq": 2
				},
				"got": {
					"freq": 5,
					"words": {
						"home": {
							"freq": 1
						},
						"the": {
							"freq": 1
						},
						"him": {
							"freq": 1
						}
					}
				},
				"must": {
					"freq": 5,
					"words": {
						"buy": {
							"freq": 1
						},
						"have": {
							"freq": 1
						},
						"be": {
							"freq": 1
						}
					}
				},
				"admire": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"hear": {
					"freq": 2,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"made": {
					"freq": 2,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"hung": {
					"freq": 2,
					"words": {
						"my": {
							"freq": 1
						}
					}
				},
				"wore": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"missed": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"go": {
					"freq": 6,
					"words": {
						"to": {
							"freq": 3
						}
					}
				},
				"am": {
					"freq": 1,
					"words": {
						"invited": {
							"freq": 1
						}
					}
				},
				"never": {
					"freq": 2,
					"words": {
						"felt": {
							"freq": 1
						}
					}
				},
				"met": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"found": {
					"freq": 2,
					"words": {
						"it": {
							"freq": 1
						}
					}
				},
				"was": {
					"freq": 7,
					"words": {
						"laughed": {
							"freq": 1
						},
						"very": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"can": {
					"freq": 3,
					"words": {
						"get": {
							"freq": 1
						},
						"swim": {
							"freq": 1
						}
					}
				},
				"live": {
					"freq": 2,
					"words": {
						"within": {
							"freq": 1
						}
					}
				},
				"spend": {
					"freq": 1,
					"words": {
						"doing": {
							"freq": 1
						}
					}
				},
				"enjoy": {
					"freq": 1,
					"words": {
						"doing": {
							"freq": 1
						}
					}
				},
				"knew": {
					"freq": 2,
					"words": {
						"i": {
							"freq": 1
						}
					}
				},
				"shouldn't": {
					"freq": 1,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"took": {
					"freq": 1,
					"words": {
						"some": {
							"freq": 1
						}
					}
				},
				"feel": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"wonder": {
					"freq": 2,
					"words": {
						"who": {
							"freq": 1
						}
					}
				},
				"carried": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"lived": {
					"freq": 2,
					"words": {
						"overseas": {
							"freq": 1
						}
					}
				},
				"could": {
					"freq": 2,
					"words": {
						"swim": {
							"freq": 1
						}
					}
				},
				"said": {
					"freq": 1
				},
				"went": {
					"freq": 2,
					"words": {
						"on": {
							"freq": 1
						}
					}
				},
				"making": {
					"freq": 1,
					"words": {
						"myself": {
							"freq": 1
						}
					}
				}
			}
		},
		"think": {
			"freq": 11,
			"words": {
				"it's": {
					"freq": 6,
					"words": {
						"time": {
							"freq": 5
						},
						"only": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"understand": {
							"freq": 1
						}
					}
				},
				"that's": {
					"freq": 1,
					"words": {
						"enough": {
							"freq": 1
						}
					}
				},
				"he": {
					"freq": 1,
					"words": {
						"is": {
							"freq": 1
						}
					}
				}
			}
		},
		"it's": {
			"freq": 23,
			"words": {
				"time": {
					"freq": 5,
					"words": {
						"for": {
							"freq": 5
						}
					}
				},
				"far": {
					"freq": 2,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"nearly": {
					"freq": 2,
					"words": {
						"lunchtime": {
							"freq": 1
						}
					}
				},
				"going": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"really": {
					"freq": 3,
					"words": {
						"noisy": {
							"freq": 1
						},
						"hot": {
							"freq": 1
						}
					}
				},
				"possible": {
					"freq": 1
				},
				"only": {
					"freq": 1,
					"words": {
						"about": {
							"freq": 1
						}
					}
				},
				"been": {
					"freq": 1,
					"words": {
						"really": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"big": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 2,
					"words": {
						"kind": {
							"freq": 1
						}
					}
				}
			}
		},
		"time": {
			"freq": 11,
			"words": {
				"for": {
					"freq": 5,
					"words": {
						"me": {
							"freq": 5
						}
					}
				},
				"do": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 2
						}
					}
				},
				"we": {
					"freq": 1,
					"words": {
						"met": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 2,
					"words": {
						"spend": {
							"freq": 1
						},
						"have": {
							"freq": 1
						}
					}
				}
			}
		},
		"for": {
			"freq": 20,
			"words": {
				"me": {
					"freq": 7,
					"words": {
						"to": {
							"freq": 5
						},
						"please": {
							"freq": 1
						}
					}
				},
				"more": {
					"freq": 3,
					"words": {
						"than": {
							"freq": 3
						}
					}
				},
				"at": {
					"freq": 1,
					"words": {
						"least": {
							"freq": 1
						}
					}
				},
				"certain": {
					"freq": 1,
					"words": {
						"how": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 3,
					"words": {
						"house": {
							"freq": 1
						},
						"moment": {
							"freq": 1
						},
						"bank": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 2,
					"words": {
						"holidays": {
							"freq": 1
						},
						"children": {
							"freq": 1
						}
					}
				},
				"ten": {
					"freq": 1,
					"words": {
						"years": {
							"freq": 1
						}
					}
				},
				"people": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"inviting": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				}
			}
		},
		"me": {
			"freq": 20,
			"words": {
				"to": {
					"freq": 7,
					"words": {
						"get": {
							"freq": 2
						},
						"walk": {
							"freq": 1
						},
						"call": {
							"freq": 1
						},
						"do": {
							"freq": 1
						},
						"your": {
							"freq": 1
						},
						"consult": {
							"freq": 1
						}
					}
				},
				"three": {
					"freq": 1,
					"words": {
						"hundred": {
							"freq": 1
						}
					}
				},
				"just": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"more": {
					"freq": 1,
					"words": {
						"than": {
							"freq": 1
						}
					}
				},
				"hear": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"what": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 2
						}
					}
				},
				"and": {
					"freq": 1
				},
				"the": {
					"freq": 1,
					"words": {
						"way": {
							"freq": 1
						}
					}
				},
				"another": {
					"freq": 1,
					"words": {
						"camera": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"discount": {
							"freq": 1
						},
						"stapler": {
							"freq": 1
						}
					}
				}
			}
		},
		"get": {
			"freq": 10,
			"words": {
				"my": {
					"freq": 1,
					"words": {
						"own": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 2,
					"words": {
						"as": {
							"freq": 1
						},
						"every": {
							"freq": 1
						}
					}
				},
				"along": {
					"freq": 2,
					"words": {
						"with": {
							"freq": 2
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"present": {
							"freq": 1
						},
						"job": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						},
						"for": {
							"freq": 1
						}
					}
				},
				"married": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"my": {
			"freq": 20,
			"words": {
				"own": {
					"freq": 1,
					"words": {
						"place": {
							"freq": 1
						}
					}
				},
				"car": {
					"freq": 1,
					"words": {
						"repaired": {
							"freq": 1
						}
					}
				},
				"boss": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"mind": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"coat": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"show": {
					"freq": 1,
					"words": {
						"last": {
							"freq": 1
						}
					}
				},
				"foot's": {
					"freq": 2,
					"words": {
						"asleep": {
							"freq": 1
						}
					}
				},
				"arm": {
					"freq": 1
				},
				"pocket": {
					"freq": 1,
					"words": {
						"picked": {
							"freq": 1
						}
					}
				},
				"homework": {
					"freq": 1,
					"words": {
						"until": {
							"freq": 1
						}
					}
				},
				"college": {
					"freq": 2,
					"words": {
						"has": {
							"freq": 1
						}
					}
				},
				"father": {
					"freq": 3,
					"words": {
						"came": {
							"freq": 1
						},
						"is": {
							"freq": 1
						}
					}
				},
				"friends": {
					"freq": 1,
					"words": {
						"like": {
							"freq": 1
						}
					}
				}
			}
		},
		"isn't": {
			"freq": 2,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"old": {
							"freq": 1
						}
					}
				},
				"working": {
					"freq": 1,
					"words": {
						"properly": {
							"freq": 1
						}
					}
				}
			}
		},
		"as": {
			"freq": 10,
			"words": {
				"old": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				},
				"he": {
					"freq": 1,
					"words": {
						"looks": {
							"freq": 1
						}
					}
				},
				"early": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"older": {
							"freq": 1
						}
					}
				},
				"well": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				},
				"soon": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"stops": {
							"freq": 1
						}
					}
				},
				"impressed": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"was": {
							"freq": 1
						}
					}
				},
				"if": {
					"freq": 1,
					"words": {
						"she": {
							"freq": 1
						}
					}
				}
			}
		},
		"old": {
			"freq": 2,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"he": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				}
			}
		},
		"don't": {
			"freq": 17,
			"words": {
				"like": {
					"freq": 3,
					"words": {
						"movies": {
							"freq": 1
						},
						"to": {
							"freq": 1
						},
						"men": {
							"freq": 1
						}
					}
				},
				"get": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"feel": {
					"freq": 2,
					"words": {
						"like": {
							"freq": 1
						},
						"up": {
							"freq": 1
						}
					}
				},
				"we": {
					"freq": 1,
					"words": {
						"stop": {
							"freq": 1
						}
					}
				},
				"care": {
					"freq": 2,
					"words": {
						"what": {
							"freq": 1
						},
						"for": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"know": {
					"freq": 2,
					"words": {
						"either": {
							"freq": 1
						},
						"when": {
							"freq": 1
						}
					}
				},
				"understand": {
					"freq": 1
				},
				"shut": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"need": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"up": {
			"freq": 11,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"early": {
							"freq": 1
						}
					}
				},
				"every": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				},
				"city": {
					"freq": 1,
					"words": {
						"life": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"mind": {
							"freq": 1
						}
					}
				},
				"or": {
					"freq": 1,
					"words": {
						"should": {
							"freq": 1
						}
					}
				},
				"his": {
					"freq": 1,
					"words": {
						"mind": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1
				},
				"to": {
					"freq": 3,
					"words": {
						"you": {
							"freq": 1
						},
						"go": {
							"freq": 1
						},
						"running": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"early": {
			"freq": 1,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				}
			}
		},
		"your": {
			"freq": 6,
			"words": {
				"older": {
					"freq": 1,
					"words": {
						"sister": {
							"freq": 1
						}
					}
				},
				"pocket": {
					"freq": 1,
					"words": {
						"may": {
							"freq": 1
						}
					}
				},
				"phone": {
					"freq": 1
				},
				"frank": {
					"freq": 1,
					"words": {
						"opinion": {
							"freq": 1
						}
					}
				},
				"winter": {
					"freq": 1,
					"words": {
						"holidays": {
							"freq": 1
						}
					}
				},
				"birthday": {
					"freq": 1,
					"words": {
						"party": {
							"freq": 1
						}
					}
				}
			}
		},
		"older": {
			"freq": 2,
			"words": {
				"sister": {
					"freq": 1
				},
				"than": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"sister": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"advised": {
			"freq": 5,
			"words": {
				"him": {
					"freq": 4,
					"words": {
						"to": {
							"freq": 2
						},
						"save": {
							"freq": 1
						},
						"against": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"become": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"teacher": {
							"freq": 1
						}
					}
				}
			}
		},
		"can": {
			"freq": 19,
			"words": {
				"you": {
					"freq": 7,
					"words": {
						"swim": {
							"freq": 1
						},
						"speak": {
							"freq": 1
						},
						"write": {
							"freq": 1
						},
						"hear": {
							"freq": 1
						}
					}
				},
				"also": {
					"freq": 1,
					"words": {
						"speak": {
							"freq": 1
						}
					}
				},
				"speak": {
					"freq": 1
				},
				"i": {
					"freq": 2,
					"words": {
						"take": {
							"freq": 1
						}
					}
				},
				"get": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				},
				"she": {
					"freq": 2,
					"words": {
						"endure": {
							"freq": 1
						}
					}
				}
			}
		},
		"i'd": {
			"freq": 13,
			"words": {
				"really": {
					"freq": 2,
					"words": {
						"like": {
							"freq": 1
						}
					}
				},
				"like": {
					"freq": 5,
					"words": {
						"one": {
							"freq": 1
						},
						"some": {
							"freq": 1
						},
						"a": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 2,
					"words": {
						"happy": {
							"freq": 1
						}
					}
				}
			}
		},
		"really": {
			"freq": 6,
			"words": {
				"like": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"nice": {
					"freq": 1
				},
				"noisy": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				},
				"hot": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"busy": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				}
			}
		},
		"like": {
			"freq": 12,
			"words": {
				"to": {
					"freq": 3,
					"words": {
						"know": {
							"freq": 1
						},
						"send": {
							"freq": 2
						}
					}
				},
				"working": {
					"freq": 1,
					"words": {
						"today": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"real": {
							"freq": 1
						},
						"room": {
							"freq": 1
						}
					}
				},
				"some": {
					"freq": 2,
					"words": {
						"more": {
							"freq": 1
						},
						"water": {
							"freq": 1
						}
					}
				},
				"one": {
					"freq": 1,
					"words": {
						"more": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"same": {
							"freq": 1
						}
					}
				},
				"men": {
					"freq": 1,
					"words": {
						"like": {
							"freq": 1
						}
					}
				}
			}
		},
		"know": {
			"freq": 6,
			"words": {
				"why": {
					"freq": 1,
					"words": {
						"he": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"it's": {
					"freq": 1,
					"words": {
						"going": {
							"freq": 1
						}
					}
				},
				"who": {
					"freq": 1,
					"words": {
						"they": {
							"freq": 1
						}
					}
				},
				"either": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"when": {
					"freq": 1
				}
			}
		},
		"why": {
			"freq": 8,
			"words": {
				"he": {
					"freq": 1,
					"words": {
						"did": {
							"freq": 1
						}
					}
				},
				"are": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"don't": {
					"freq": 1,
					"words": {
						"we": {
							"freq": 1
						}
					}
				},
				"do": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"he": {
			"freq": 79,
			"words": {
				"did": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"has": {
					"freq": 8,
					"words": {
						"not": {
							"freq": 1
						},
						"the": {
							"freq": 1
						},
						"a": {
							"freq": 1
						},
						"made": {
							"freq": 1
						}
					}
				},
				"lives": {
					"freq": 2,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 7,
					"words": {
						"two": {
							"freq": 1
						},
						"suffering": {
							"freq": 1
						},
						"a": {
							"freq": 1
						},
						"lying": {
							"freq": 1
						}
					}
				},
				"can": {
					"freq": 2,
					"words": {
						"also": {
							"freq": 1
						}
					}
				},
				"seems": {
					"freq": 2,
					"words": {
						"unable": {
							"freq": 1
						}
					}
				},
				"know": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"will": {
					"freq": 1,
					"words": {
						"help": {
							"freq": 1
						}
					}
				},
				"loved": {
					"freq": 2,
					"words": {
						"her": {
							"freq": 1
						}
					}
				},
				"studied": {
					"freq": 2
				},
				"said": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"wouldn't": {
					"freq": 1,
					"words": {
						"give": {
							"freq": 1
						}
					}
				},
				"fell": {
					"freq": 2,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"likes": {
					"freq": 2,
					"words": {
						"it": {
							"freq": 1
						}
					}
				},
				"came": {
					"freq": 4,
					"words": {
						"by": {
							"freq": 2
						}
					}
				},
				"knows": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"beat": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"accepted": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"made": {
					"freq": 2,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"set": {
					"freq": 2,
					"words": {
						"out": {
							"freq": 1
						}
					}
				},
				"hired": {
					"freq": 2,
					"words": {
						"some": {
							"freq": 1
						}
					}
				},
				"come": {
					"freq": 1,
					"words": {
						"tomorrow": {
							"freq": 1
						}
					}
				},
				"finished": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"achieved": {
					"freq": 2,
					"words": {
						"his": {
							"freq": 1
						}
					}
				}
			}
		},
		"that": {
			"freq": 14,
			"words": {
				"sort": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 3,
					"words": {
						"love": {
							"freq": 1
						},
						"didn't": {
							"freq": 1
						},
						"want": {
							"freq": 1
						}
					}
				},
				"sounds": {
					"freq": 2,
					"words": {
						"really": {
							"freq": 1
						}
					}
				},
				"he": {
					"freq": 2,
					"words": {
						"will": {
							"freq": 1
						},
						"wouldn't": {
							"freq": 1
						}
					}
				},
				"school's": {
					"freq": 2,
					"words": {
						"closed": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"do": {
							"freq": 1
						}
					}
				}
			}
		},
		"sort": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"thing": {
							"freq": 1
						}
					}
				}
			}
		},
		"far": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				}
			}
		},
		"agree": {
			"freq": 1,
			"words": {
				"with": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"with": {
			"freq": 6,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"native": {
							"freq": 1
						}
					}
				},
				"his": {
					"freq": 1,
					"words": {
						"family": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"boss": {
							"freq": 1
						}
					}
				},
				"her": {
					"freq": 1,
					"words": {
						"at": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"high": {
							"freq": 1
						}
					}
				}
			}
		},
		"boss": {
			"freq": 2,
			"words": {
				"just": {
					"freq": 1,
					"words": {
						"chewed": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"tell": {
							"freq": 1
						}
					}
				}
			}
		},
		"just": {
			"freq": 4,
			"words": {
				"chewed": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"little": {
							"freq": 1
						}
					}
				},
				"walk": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				},
				"like": {
					"freq": 1,
					"words": {
						"brothers": {
							"freq": 1
						}
					}
				}
			}
		},
		"chewed": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				}
			}
		},
		"they": {
			"freq": 12,
			"words": {
				"were": {
					"freq": 2,
					"words": {
						"all": {
							"freq": 1
						}
					}
				},
				"drank": {
					"freq": 2,
					"words": {
						"two": {
							"freq": 1
						}
					}
				},
				"chatted": {
					"freq": 2,
					"words": {
						"over": {
							"freq": 1
						}
					}
				},
				"teased": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"were": {
			"freq": 3,
			"words": {
				"all": {
					"freq": 1,
					"words": {
						"surprised": {
							"freq": 1
						}
					}
				},
				"somewhere": {
					"freq": 1,
					"words": {
						"else": {
							"freq": 1
						}
					}
				},
				"saved": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				}
			}
		},
		"all": {
			"freq": 16,
			"words": {
				"surprised": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 4,
					"words": {
						"boys": {
							"freq": 1
						},
						"way": {
							"freq": 1
						},
						"passengers": {
							"freq": 1
						}
					}
				},
				"of": {
					"freq": 4,
					"words": {
						"them": {
							"freq": 2
						}
					}
				},
				"day": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 2,
					"words": {
						"friends": {
							"freq": 1
						}
					}
				}
			}
		},
		"surprised": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"see": {
							"freq": 1
						}
					}
				},
				"when": {
					"freq": 1,
					"words": {
						"she": {
							"freq": 1
						}
					}
				}
			}
		},
		"see": {
			"freq": 4,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"him": {
					"freq": 1,
					"words": {
						"off": {
							"freq": 1
						}
					}
				},
				"them": {
					"freq": 1,
					"words": {
						"again": {
							"freq": 1
						}
					}
				},
				"if": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"has": {
			"freq": 8,
			"words": {
				"not": {
					"freq": 1,
					"words": {
						"eaten": {
							"freq": 1
						}
					}
				},
				"graduated": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"studied": {
					"freq": 1
				},
				"about": {
					"freq": 1,
					"words": {
						"2,000": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"least": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"lot": {
							"freq": 1
						}
					}
				},
				"six": {
					"freq": 1,
					"words": {
						"rooms": {
							"freq": 1
						}
					}
				},
				"made": {
					"freq": 1,
					"words": {
						"rapid": {
							"freq": 1
						}
					}
				}
			}
		},
		"not": {
			"freq": 9,
			"words": {
				"eaten": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"ready": {
					"freq": 1,
					"words": {
						"yet": {
							"freq": 1
						}
					}
				},
				"here": {
					"freq": 1,
					"words": {
						"right": {
							"freq": 1
						}
					}
				},
				"go": {
					"freq": 1,
					"words": {
						"today": {
							"freq": 1
						}
					}
				},
				"really": {
					"freq": 1
				},
				"a": {
					"freq": 1,
					"words": {
						"lawyer": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 1,
					"words": {
						"clearly": {
							"freq": 1
						}
					}
				},
				"sure": {
					"freq": 1,
					"words": {
						"what's": {
							"freq": 1
						}
					}
				},
				"this": {
					"freq": 1,
					"words": {
						"time": {
							"freq": 1
						}
					}
				}
			}
		},
		"eaten": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"decent": {
							"freq": 1
						}
					}
				}
			}
		},
		"a": {
			"freq": 47,
			"words": {
				"decent": {
					"freq": 1,
					"words": {
						"meal": {
							"freq": 1
						}
					}
				},
				"long": {
					"freq": 2,
					"words": {
						"time": {
							"freq": 1
						},
						"trip": {
							"freq": 1
						}
					}
				},
				"cozy": {
					"freq": 1,
					"words": {
						"little": {
							"freq": 1
						}
					}
				},
				"late": {
					"freq": 1,
					"words": {
						"bloomer": {
							"freq": 1
						}
					}
				},
				"real": {
					"freq": 1,
					"words": {
						"baby": {
							"freq": 1
						}
					}
				},
				"bite": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"few": {
					"freq": 1,
					"words": {
						"pages": {
							"freq": 1
						}
					}
				},
				"lot": {
					"freq": 5,
					"words": {
						"of": {
							"freq": 4
						}
					}
				},
				"native": {
					"freq": 1,
					"words": {
						"speaker": {
							"freq": 1
						}
					}
				},
				"small": {
					"freq": 1,
					"words": {
						"flashlight": {
							"freq": 1
						}
					}
				},
				"trip": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"glass": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"lawyer": {
					"freq": 1
				},
				"present": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"little": {
					"freq": 3,
					"words": {
						"better": {
							"freq": 1
						}
					}
				},
				"schools": {
					"freq": 1,
					"words": {
						"closed": {
							"freq": 1
						}
					}
				},
				"new": {
					"freq": 1,
					"words": {
						"car": {
							"freq": 1
						}
					}
				},
				"formal": {
					"freq": 1,
					"words": {
						"speech": {
							"freq": 1
						}
					}
				},
				"light": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"room": {
					"freq": 1,
					"words": {
						"please": {
							"freq": 1
						}
					}
				},
				"press": {
					"freq": 1,
					"words": {
						"conference": {
							"freq": 1
						}
					}
				},
				"good": {
					"freq": 2,
					"words": {
						"choice": {
							"freq": 1
						},
						"president": {
							"freq": 1
						}
					}
				},
				"hard": {
					"freq": 1,
					"words": {
						"time": {
							"freq": 1
						}
					}
				},
				"heavy": {
					"freq": 2,
					"words": {
						"snowstorm": {
							"freq": 1
						}
					}
				},
				"bit": {
					"freq": 1,
					"words": {
						"short": {
							"freq": 1
						}
					}
				},
				"bank": {
					"freq": 1
				},
				"nice": {
					"freq": 1,
					"words": {
						"time": {
							"freq": 1
						}
					}
				},
				"narrow": {
					"freq": 1,
					"words": {
						"escape": {
							"freq": 1
						}
					}
				},
				"lonely": {
					"freq": 1,
					"words": {
						"journey": {
							"freq": 1
						}
					}
				},
				"big": {
					"freq": 1,
					"words": {
						"change": {
							"freq": 1
						}
					}
				},
				"skirt": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"restaurant": {
					"freq": 1,
					"words": {
						"near": {
							"freq": 1
						}
					}
				},
				"student": {
					"freq": 2,
					"words": {
						"raised": {
							"freq": 1
						}
					}
				}
			}
		},
		"decent": {
			"freq": 1,
			"words": {
				"meal": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				}
			}
		},
		"meal": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"in": {
			"freq": 13,
			"words": {
				"a": {
					"freq": 3,
					"words": {
						"long": {
							"freq": 1
						},
						"cozy": {
							"freq": 1
						},
						"hotel": {
							"freq": 1
						}
					}
				},
				"love": {
					"freq": 2,
					"words": {
						"with": {
							"freq": 2
						}
					}
				},
				"learning": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"pocket": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 5,
					"words": {
						"bath": {
							"freq": 1
						},
						"country": {
							"freq": 1
						},
						"hall": {
							"freq": 1
						},
						"traffic": {
							"freq": 1
						},
						"distance": {
							"freq": 1
						}
					}
				},
				"jail": {
					"freq": 1,
					"words": {
						"last": {
							"freq": 1
						}
					}
				}
			}
		},
		"was": {
			"freq": 16,
			"words": {
				"making": {
					"freq": 1,
					"words": {
						"tea": {
							"freq": 1
						}
					}
				},
				"also": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 2,
					"words": {
						"surprised": {
							"freq": 1
						},
						"glad": {
							"freq": 1
						}
					}
				},
				"aching": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				},
				"deeply": {
					"freq": 1,
					"words": {
						"affected": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"last": {
							"freq": 1
						}
					}
				},
				"quite": {
					"freq": 1,
					"words": {
						"dark": {
							"freq": 1
						}
					}
				},
				"laughed": {
					"freq": 1,
					"words": {
						"at": {
							"freq": 1
						}
					}
				},
				"put": {
					"freq": 1,
					"words": {
						"off": {
							"freq": 1
						}
					}
				},
				"injured": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"afternoon": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"child": {
							"freq": 1
						},
						"success": {
							"freq": 1
						}
					}
				},
				"advised": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				}
			}
		},
		"lives": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"cozy": {
			"freq": 1,
			"words": {
				"little": {
					"freq": 1,
					"words": {
						"house": {
							"freq": 1
						}
					}
				}
			}
		},
		"accidents": {
			"freq": 3,
			"words": {
				"will": {
					"freq": 2,
					"words": {
						"happen": {
							"freq": 1
						}
					}
				}
			}
		},
		"never": {
			"freq": 4,
			"words": {
				"forget": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"felt": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				},
				"eats": {
					"freq": 1,
					"words": {
						"any": {
							"freq": 1
						}
					}
				},
				"lived": {
					"freq": 1,
					"words": {
						"alone": {
							"freq": 1
						}
					}
				}
			}
		},
		"forget": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"kindness": {
							"freq": 1
						}
					}
				}
			}
		},
		"is": {
			"freq": 25,
			"words": {
				"two": {
					"freq": 1,
					"words": {
						"years": {
							"freq": 1
						}
					}
				},
				"near": {
					"freq": 1,
					"words": {
						"completion": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 2,
					"words": {
						"friendly": {
							"freq": 1
						},
						"the": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"right": {
							"freq": 1
						}
					}
				},
				"in": {
					"freq": 1,
					"words": {
						"prison": {
							"freq": 1
						}
					}
				},
				"room": {
					"freq": 1,
					"words": {
						"105": {
							"freq": 1
						}
					}
				},
				"cooking": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"going": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 2,
					"words": {
						"salad": {
							"freq": 1
						},
						"father": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1,
					"words": {
						"right": {
							"freq": 1
						}
					}
				},
				"suffering": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 3,
					"words": {
						"beauty": {
							"freq": 1
						},
						"good": {
							"freq": 1
						},
						"teacher": {
							"freq": 1
						}
					}
				},
				"wrong": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"fast": {
					"freq": 1,
					"words": {
						"asleep": {
							"freq": 1
						}
					}
				},
				"heavier": {
					"freq": 1,
					"words": {
						"than": {
							"freq": 1
						}
					}
				},
				"there": {
					"freq": 1,
					"words": {
						"one": {
							"freq": 1
						}
					}
				},
				"an": {
					"freq": 1,
					"words": {
						"urgent": {
							"freq": 1
						}
					}
				},
				"anyone": {
					"freq": 2,
					"words": {
						"else": {
							"freq": 1
						}
					}
				}
			}
		},
		"two": {
			"freq": 3,
			"words": {
				"years": {
					"freq": 1,
					"words": {
						"older": {
							"freq": 1
						}
					}
				},
				"bottles": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"hours": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"years": {
			"freq": 1,
			"words": {
				"older": {
					"freq": 1,
					"words": {
						"than": {
							"freq": 1
						}
					}
				}
			}
		},
		"he's": {
			"freq": 13,
			"words": {
				"a": {
					"freq": 3,
					"words": {
						"late": {
							"freq": 1
						},
						"doctor": {
							"freq": 1
						}
					}
				},
				"agreed": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"accustomed": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"saving": {
					"freq": 2,
					"words": {
						"up": {
							"freq": 1
						}
					}
				}
			}
		},
		"this": {
			"freq": 21,
			"words": {
				"building": {
					"freq": 2,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"would": {
					"freq": 1,
					"words": {
						"be": {
							"freq": 1
						}
					}
				},
				"way": {
					"freq": 1,
					"words": {
						"before": {
							"freq": 1
						}
					}
				},
				"winter": {
					"freq": 2,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"book": {
					"freq": 2,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"morning": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"tastes": {
					"freq": 2,
					"words": {
						"good": {
							"freq": 1
						}
					}
				},
				"time": {
					"freq": 1
				},
				"house": {
					"freq": 2,
					"words": {
						"has": {
							"freq": 1
						}
					}
				}
			}
		},
		"building": {
			"freq": 1,
			"words": {
				"is": {
					"freq": 1,
					"words": {
						"near": {
							"freq": 1
						}
					}
				}
			}
		},
		"also": {
			"freq": 1,
			"words": {
				"speak": {
					"freq": 1,
					"words": {
						"french": {
							"freq": 1
						}
					}
				}
			}
		},
		"accomplish": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"goals": {
							"freq": 1
						}
					}
				}
			}
		},
		"fell": {
			"freq": 4,
			"words": {
				"in": {
					"freq": 2,
					"words": {
						"love": {
							"freq": 2
						}
					}
				},
				"asleep": {
					"freq": 2,
					"words": {
						"while": {
							"freq": 1
						},
						"before": {
							"freq": 1
						}
					}
				}
			}
		},
		"love": {
			"freq": 2,
			"words": {
				"with": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						},
						"her": {
							"freq": 1
						}
					}
				}
			}
		},
		"we": {
			"freq": 39,
			"words": {
				"adopted": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"stop": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"ate": {
					"freq": 2,
					"words": {
						"some": {
							"freq": 1
						}
					}
				},
				"appreciate": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"are": {
					"freq": 2,
					"words": {
						"acquainted": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 4,
					"words": {
						"to": {
							"freq": 1
						},
						"bottled": {
							"freq": 1
						}
					}
				},
				"don't": {
					"freq": 2,
					"words": {
						"care": {
							"freq": 1
						}
					}
				},
				"lost": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"deliver": {
					"freq": 1,
					"words": {
						"them": {
							"freq": 1
						}
					}
				},
				"chartered": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"felt": {
					"freq": 2,
					"words": {
						"relieved": {
							"freq": 1
						}
					}
				},
				"saw": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"had": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"should": {
					"freq": 2,
					"words": {
						"start": {
							"freq": 1
						}
					}
				}
			}
		},
		"adopted": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"child": {
							"freq": 1
						}
					}
				}
			}
		},
		"slipped": {
			"freq": 1,
			"words": {
				"on": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"on": {
			"freq": 10,
			"words": {
				"the": {
					"freq": 4,
					"words": {
						"ice": {
							"freq": 1
						},
						"ship": {
							"freq": 1
						},
						"desk": {
							"freq": 1
						},
						"train": {
							"freq": 1
						}
					}
				},
				"friendly": {
					"freq": 1,
					"words": {
						"terms": {
							"freq": 1
						}
					}
				},
				"every": {
					"freq": 1,
					"words": {
						"other": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"trip": {
							"freq": 1
						},
						"lonely": {
							"freq": 1
						}
					}
				},
				"page": {
					"freq": 1,
					"words": {
						"30": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"back": {
							"freq": 1
						}
					}
				}
			}
		},
		"ice": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"hurt": {
							"freq": 1
						}
					}
				}
			}
		},
		"and": {
			"freq": 13,
			"words": {
				"hurt": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 2,
					"words": {
						"have": {
							"freq": 1
						},
						"feel": {
							"freq": 1
						}
					}
				},
				"sue": {
					"freq": 1,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"live": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"was": {
					"freq": 1,
					"words": {
						"successful": {
							"freq": 1
						}
					}
				},
				"pick": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"never": {
					"freq": 1,
					"words": {
						"eats": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"blouse": {
							"freq": 1
						}
					}
				},
				"ordered": {
					"freq": 1,
					"words": {
						"another": {
							"freq": 1
						}
					}
				}
			}
		},
		"hurt": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"leg": {
							"freq": 1
						}
					}
				}
			}
		},
		"i'm": {
			"freq": 27,
			"words": {
				"not": {
					"freq": 3,
					"words": {
						"ready": {
							"freq": 1
						},
						"sure": {
							"freq": 1
						}
					}
				},
				"afraid": {
					"freq": 3,
					"words": {
						"of": {
							"freq": 1
						},
						"i": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"completely": {
					"freq": 2,
					"words": {
						"exhausted": {
							"freq": 1
						}
					}
				},
				"sorry": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 2,
					"words": {
						"fat": {
							"freq": 1
						}
					}
				},
				"looking": {
					"freq": 4,
					"words": {
						"for": {
							"freq": 2
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"bit": {
							"freq": 1
						}
					}
				}
			}
		},
		"about": {
			"freq": 6,
			"words": {
				"5": {
					"freq": 1,
					"words": {
						"dollars": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"leave": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1
				},
				"the": {
					"freq": 2,
					"words": {
						"accident": {
							"freq": 1
						},
						"surprise": {
							"freq": 1
						}
					}
				},
				"2,000": {
					"freq": 1,
					"words": {
						"books": {
							"freq": 1
						}
					}
				}
			}
		},
		"small": {
			"freq": 3,
			"words": {
				"please": {
					"freq": 1
				},
				"flashlight": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				}
			}
		},
		"feel": {
			"freq": 4,
			"words": {
				"like": {
					"freq": 1,
					"words": {
						"working": {
							"freq": 1
						}
					}
				},
				"at": {
					"freq": 1,
					"words": {
						"home": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"little": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"acted": {
			"freq": 2,
			"words": {
				"like": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"as": {
					"freq": 1,
					"words": {
						"if": {
							"freq": 1
						}
					}
				}
			}
		},
		"went": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1,
					"words": {
						"reading": {
							"freq": 1
						}
					}
				}
			}
		},
		"station": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"see": {
							"freq": 1
						}
					}
				}
			}
		},
		"friendly": {
			"freq": 1,
			"words": {
				"terms": {
					"freq": 1,
					"words": {
						"with": {
							"freq": 1
						}
					}
				}
			}
		},
		"terms": {
			"freq": 1,
			"words": {
				"with": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"are": {
			"freq": 20,
			"words": {
				"you": {
					"freq": 11,
					"words": {
						"laughing": {
							"freq": 1
						},
						"allergic": {
							"freq": 1
						},
						"sure": {
							"freq": 1
						},
						"going": {
							"freq": 3
						},
						"from": {
							"freq": 1
						}
					}
				},
				"slow": {
					"freq": 1,
					"words": {
						"right": {
							"freq": 1
						}
					}
				},
				"acquainted": {
					"freq": 1,
					"words": {
						"with": {
							"freq": 1
						}
					}
				},
				"many": {
					"freq": 1,
					"words": {
						"rats": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 1,
					"words": {
						"friendly": {
							"freq": 1
						}
					}
				},
				"not": {
					"freq": 1,
					"words": {
						"poor": {
							"freq": 1
						}
					}
				}
			}
		},
		"oh": {
			"freq": 6
		},
		"thought": {
			"freq": 3,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"said": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"having": {
							"freq": 1
						}
					}
				},
				"doing": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				}
			}
		},
		"said": {
			"freq": 3,
			"words": {
				"laura": {
					"freq": 1
				},
				"that": {
					"freq": 1,
					"words": {
						"he": {
							"freq": 1
						}
					}
				}
			}
		},
		"laura": {
			"freq": 1
		},
		"sorry": {
			"freq": 5,
			"words": {
				"about": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"interrupt": {
							"freq": 1
						}
					}
				}
			}
		},
		"right": {
			"freq": 3,
			"words": {
				"number": {
					"freq": 1
				},
				"now": {
					"freq": 1
				}
			}
		},
		"number": {
			"freq": 1
		},
		"but": {
			"freq": 4,
			"words": {
				"heather's": {
					"freq": 1,
					"words": {
						"not": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"accept": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"think": {
							"freq": 1
						}
					}
				}
			}
		},
		"heather's": {
			"freq": 1,
			"words": {
				"not": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				}
			}
		},
		"here": {
			"freq": 9,
			"words": {
				"right": {
					"freq": 1,
					"words": {
						"now": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"comes": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"think": {
							"freq": 1
						}
					}
				},
				"all": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				}
			}
		},
		"nearly": {
			"freq": 1,
			"words": {
				"lunchtime": {
					"freq": 1
				}
			}
		},
		"lunchtime": {
			"freq": 1
		},
		"stop": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"have": {
							"freq": 1
						}
					}
				}
			}
		},
		"bite": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"eat": {
							"freq": 1
						}
					}
				}
			}
		},
		"drank": {
			"freq": 1,
			"words": {
				"two": {
					"freq": 1,
					"words": {
						"bottles": {
							"freq": 1
						}
					}
				}
			}
		},
		"bottles": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"wine": {
							"freq": 1
						}
					}
				}
			}
		},
		"still": {
			"freq": 2,
			"words": {
				"loves": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"not": {
					"freq": 1,
					"words": {
						"finished": {
							"freq": 1
						}
					}
				}
			}
		},
		"chatted": {
			"freq": 1,
			"words": {
				"over": {
					"freq": 1,
					"words": {
						"coffee": {
							"freq": 1
						}
					}
				}
			}
		},
		"over": {
			"freq": 1,
			"words": {
				"coffee": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"coffee": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"more": {
							"freq": 1
						}
					}
				}
			}
		},
		"more": {
			"freq": 5,
			"words": {
				"than": {
					"freq": 4,
					"words": {
						"two": {
							"freq": 2
						},
						"a": {
							"freq": 1
						},
						"thirty": {
							"freq": 1
						}
					}
				},
				"time": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"than": {
			"freq": 4,
			"words": {
				"two": {
					"freq": 2,
					"words": {
						"hours": {
							"freq": 2
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"year": {
							"freq": 1
						}
					}
				},
				"thirty": {
					"freq": 1,
					"words": {
						"years": {
							"freq": 1
						}
					}
				}
			}
		},
		"play": {
			"freq": 1,
			"words": {
				"tennis": {
					"freq": 1,
					"words": {
						"as": {
							"freq": 1
						}
					}
				}
			}
		},
		"tennis": {
			"freq": 1,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"well": {
							"freq": 1
						}
					}
				}
			}
		},
		"well": {
			"freq": 5,
			"words": {
				"as": {
					"freq": 1
				},
				"even": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				}
			}
		},
		"ate": {
			"freq": 1,
			"words": {
				"some": {
					"freq": 1,
					"words": {
						"apples": {
							"freq": 1
						}
					}
				}
			}
		},
		"it": {
			"freq": 33,
			"words": {
				"cost": {
					"freq": 2,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"took": {
					"freq": 2,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"rained": {
					"freq": 2,
					"words": {
						"yesterday": {
							"freq": 1
						}
					}
				},
				"take": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"stops": {
					"freq": 1,
					"words": {
						"raining": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 4,
					"words": {
						"going": {
							"freq": 1
						},
						"wrong": {
							"freq": 1
						}
					}
				},
				"was": {
					"freq": 2,
					"words": {
						"quite": {
							"freq": 1
						}
					}
				},
				"down": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 2,
					"words": {
						"her": {
							"freq": 1
						},
						"open": {
							"freq": 1
						}
					}
				},
				"difficult": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"very": {
					"freq": 1,
					"words": {
						"much": {
							"freq": 1
						}
					}
				},
				"overnight": {
					"freq": 1,
					"words": {
						"or": {
							"freq": 1
						}
					}
				},
				"snowed": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"cost": {
			"freq": 1,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"three": {
							"freq": 1
						}
					}
				}
			}
		},
		"three": {
			"freq": 1,
			"words": {
				"hundred": {
					"freq": 1,
					"words": {
						"dollars": {
							"freq": 1
						}
					}
				}
			}
		},
		"hundred": {
			"freq": 1,
			"words": {
				"dollars": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"dollars": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"have": {
							"freq": 1
						}
					}
				}
			}
		},
		"seems": {
			"freq": 1,
			"words": {
				"unable": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"unable": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"swim": {
							"freq": 1
						}
					}
				}
			}
		},
		"write": {
			"freq": 5,
			"words": {
				"on": {
					"freq": 2,
					"words": {
						"every": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"down": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"letter": {
							"freq": 1
						}
					}
				}
			}
		},
		"every": {
			"freq": 5,
			"words": {
				"other": {
					"freq": 1,
					"words": {
						"line": {
							"freq": 1
						}
					}
				},
				"student": {
					"freq": 2,
					"words": {
						"who": {
							"freq": 1
						}
					}
				},
				"now": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				}
			}
		},
		"had": {
			"freq": 8,
			"words": {
				"no": {
					"freq": 2,
					"words": {
						"difficulty": {
							"freq": 1
						},
						"choice": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 2,
					"words": {
						"walk": {
							"freq": 1
						},
						"postpone": {
							"freq": 1
						}
					}
				},
				"nothing": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"pocket": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"nice": {
							"freq": 1
						},
						"narrow": {
							"freq": 1
						}
					}
				}
			}
		},
		"no": {
			"freq": 18,
			"words": {
				"difficulty": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				},
				"choice": {
					"freq": 1,
					"words": {
						"but": {
							"freq": 1
						}
					}
				},
				"one": {
					"freq": 2,
					"words": {
						"knew": {
							"freq": 1
						}
					}
				}
			}
		},
		"difficulty": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"learning": {
							"freq": 1
						}
					}
				}
			}
		},
		"learning": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"poem": {
							"freq": 1
						}
					}
				}
			}
		},
		"poem": {
			"freq": 1,
			"words": {
				"by": {
					"freq": 1,
					"words": {
						"heart": {
							"freq": 1
						}
					}
				}
			}
		},
		"took": {
			"freq": 5,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"more": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"trip": {
							"freq": 1
						}
					}
				},
				"some": {
					"freq": 1,
					"words": {
						"medicine": {
							"freq": 1
						}
					}
				},
				"care": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"him": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"hours": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"translate": {
							"freq": 1
						}
					}
				}
			}
		},
		"translate": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"few": {
							"freq": 1
						}
					}
				}
			}
		},
		"few": {
			"freq": 1,
			"words": {
				"pages": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"pages": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1
				}
			}
		},
		"how": {
			"freq": 30,
			"words": {
				"much": {
					"freq": 4,
					"words": {
						"food": {
							"freq": 1
						},
						"time": {
							"freq": 1
						}
					}
				},
				"long": {
					"freq": 4,
					"words": {
						"do": {
							"freq": 1
						},
						"will": {
							"freq": 1
						}
					}
				},
				"does": {
					"freq": 2,
					"words": {
						"it": {
							"freq": 1
						}
					}
				},
				"could": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"old": {
					"freq": 2,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"accident": {
							"freq": 1
						}
					}
				},
				"was": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 2,
					"words": {
						"upload": {
							"freq": 1
						},
						"play": {
							"freq": 1
						}
					}
				},
				"do": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"much": {
			"freq": 3,
			"words": {
				"food": {
					"freq": 1,
					"words": {
						"should": {
							"freq": 1
						}
					}
				},
				"time": {
					"freq": 1,
					"words": {
						"do": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"inviting": {
							"freq": 1
						}
					}
				}
			}
		},
		"food": {
			"freq": 1,
			"words": {
				"should": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"should": {
			"freq": 5,
			"words": {
				"i": {
					"freq": 1,
					"words": {
						"be": {
							"freq": 1
						}
					}
				},
				"give": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 1,
					"words": {
						"left": {
							"freq": 1
						}
					}
				},
				"we": {
					"freq": 1,
					"words": {
						"deliver": {
							"freq": 1
						}
					}
				},
				"start": {
					"freq": 1,
					"words": {
						"getting": {
							"freq": 1
						}
					}
				}
			}
		},
		"be": {
			"freq": 12,
			"words": {
				"feeding": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				},
				"unpleasant": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"fast": {
					"freq": 1,
					"words": {
						"asleep": {
							"freq": 1
						}
					}
				},
				"easy": {
					"freq": 1
				},
				"home": {
					"freq": 1,
					"words": {
						"at": {
							"freq": 1
						}
					}
				},
				"all": {
					"freq": 1,
					"words": {
						"right": {
							"freq": 1
						}
					}
				},
				"happy": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"pilot": {
							"freq": 1
						}
					}
				},
				"quiet": {
					"freq": 2,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"leaving": {
					"freq": 1
				}
			}
		},
		"feeding": {
			"freq": 1,
			"words": {
				"my": {
					"freq": 1,
					"words": {
						"dog": {
							"freq": 1
						}
					}
				}
			}
		},
		"allergic": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"anything": {
							"freq": 1
						}
					}
				}
			}
		},
		"does": {
			"freq": 10,
			"words": {
				"he": {
					"freq": 2,
					"words": {
						"know": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"taste": {
							"freq": 1
						}
					}
				},
				"she": {
					"freq": 1,
					"words": {
						"live": {
							"freq": 1
						}
					}
				},
				"that": {
					"freq": 1,
					"words": {
						"mean": {
							"freq": 1
						}
					}
				},
				"school": {
					"freq": 1,
					"words": {
						"let": {
							"freq": 1
						}
					}
				}
			}
		},
		"stole": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"lot": {
							"freq": 1
						}
					}
				}
			}
		},
		"lot": {
			"freq": 5,
			"words": {
				"of": {
					"freq": 4,
					"words": {
						"money": {
							"freq": 1
						},
						"people": {
							"freq": 1
						},
						"things": {
							"freq": 1
						},
						"work": {
							"freq": 1
						}
					}
				}
			}
		},
		"of": {
			"freq": 17,
			"words": {
				"money": {
					"freq": 2,
					"words": {
						"from": {
							"freq": 1
						},
						"now": {
							"freq": 1
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"answer": {
							"freq": 1
						}
					}
				},
				"technical": {
					"freq": 1,
					"words": {
						"knowledge": {
							"freq": 1
						}
					}
				},
				"batteries": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				},
				"them": {
					"freq": 2,
					"words": {
						"are": {
							"freq": 1
						},
						"went": {
							"freq": 1
						}
					}
				},
				"white": {
					"freq": 1,
					"words": {
						"wine": {
							"freq": 1
						}
					}
				},
				"us": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 2,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 2,
					"words": {
						"station": {
							"freq": 1
						},
						"children": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"arm": {
							"freq": 1
						}
					}
				},
				"music": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"things": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"work": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"money": {
			"freq": 3,
			"words": {
				"from": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 2
						}
					}
				},
				"of": {
					"freq": 1,
					"words": {
						"us": {
							"freq": 1
						}
					}
				}
			}
		},
		"from": {
			"freq": 9,
			"words": {
				"him": {
					"freq": 3,
					"words": {
						"every": {
							"freq": 1
						},
						"even": {
							"freq": 1
						}
					}
				},
				"our": {
					"freq": 1,
					"words": {
						"university": {
							"freq": 1
						}
					}
				},
				"being": {
					"freq": 1,
					"words": {
						"promoted": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"headache": {
							"freq": 1
						}
					}
				},
				"this": {
					"freq": 1,
					"words": {
						"mess": {
							"freq": 1
						}
					}
				},
				"here": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				},
				"going": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				}
			}
		},
		"so": {
			"freq": 4,
			"words": {
				"now": {
					"freq": 1,
					"words": {
						"she": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"had": {
							"freq": 1
						}
					}
				},
				"nice": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"much": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"now": {
			"freq": 6,
			"words": {
				"she": {
					"freq": 1,
					"words": {
						"is": {
							"freq": 1
						}
					}
				},
				"and": {
					"freq": 1,
					"words": {
						"then": {
							"freq": 1
						}
					}
				},
				"let's": {
					"freq": 2,
					"words": {
						"begin": {
							"freq": 1
						}
					}
				}
			}
		},
		"student": {
			"freq": 2,
			"words": {
				"who": {
					"freq": 1,
					"words": {
						"has": {
							"freq": 1
						}
					}
				},
				"raised": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				}
			}
		},
		"who": {
			"freq": 3,
			"words": {
				"has": {
					"freq": 1,
					"words": {
						"graduated": {
							"freq": 1
						}
					}
				},
				"they": {
					"freq": 1,
					"words": {
						"are": {
							"freq": 1
						}
					}
				},
				"started": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				}
			}
		},
		"graduated": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"our": {
							"freq": 1
						}
					}
				}
			}
		},
		"our": {
			"freq": 4,
			"words": {
				"university": {
					"freq": 1,
					"words": {
						"has": {
							"freq": 1
						}
					}
				},
				"dorm's": {
					"freq": 2,
					"words": {
						"heating": {
							"freq": 1
						}
					}
				}
			}
		},
		"university": {
			"freq": 1,
			"words": {
				"has": {
					"freq": 1,
					"words": {
						"studied": {
							"freq": 1
						}
					}
				}
			}
		},
		"studied": {
			"freq": 2
		},
		"native": {
			"freq": 1,
			"words": {
				"speaker": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"speaker": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"at": {
							"freq": 1
						}
					}
				}
			}
		},
		"least": {
			"freq": 2,
			"words": {
				"two": {
					"freq": 1,
					"words": {
						"years": {
							"freq": 1
						}
					}
				},
				"money": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"agreed": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"do": {
							"freq": 1
						}
					}
				}
			}
		},
		"having": {
			"freq": 5,
			"words": {
				"a": {
					"freq": 2,
					"words": {
						"small": {
							"freq": 1
						}
					}
				},
				"dinner": {
					"freq": 1,
					"words": {
						"with": {
							"freq": 1
						}
					}
				},
				"stolen": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"flashlight": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				}
			}
		},
		"pocket": {
			"freq": 2,
			"words": {
				"may": {
					"freq": 1,
					"words": {
						"come": {
							"freq": 1
						}
					}
				},
				"picked": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				}
			}
		},
		"may": {
			"freq": 1,
			"words": {
				"come": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				}
			}
		},
		"come": {
			"freq": 4,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"handy": {
							"freq": 1
						}
					}
				},
				"with": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"and": {
					"freq": 1,
					"words": {
						"pick": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"long": {
			"freq": 2,
			"words": {
				"do": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				},
				"will": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				}
			}
		},
		"wait": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"delivery": {
							"freq": 1
						}
					}
				}
			}
		},
		"will": {
			"freq": 18,
			"words": {
				"it": {
					"freq": 1,
					"words": {
						"take": {
							"freq": 1
						}
					}
				},
				"help": {
					"freq": 1,
					"words": {
						"us": {
							"freq": 1
						}
					}
				},
				"go": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"leave": {
					"freq": 1,
					"words": {
						"japan": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 6,
					"words": {
						"come": {
							"freq": 1
						},
						"please": {
							"freq": 2
						}
					}
				},
				"hold": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"get": {
					"freq": 1,
					"words": {
						"married": {
							"freq": 1
						}
					}
				},
				"he": {
					"freq": 2,
					"words": {
						"come": {
							"freq": 1
						}
					}
				}
			}
		},
		"take": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"get": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"message": {
							"freq": 1
						}
					}
				}
			}
		},
		"going": {
			"freq": 5,
			"words": {
				"to": {
					"freq": 5,
					"words": {
						"be": {
							"freq": 1
						},
						"stay": {
							"freq": 1
						},
						"rain": {
							"freq": 1
						},
						"work": {
							"freq": 1
						},
						"do": {
							"freq": 1
						}
					}
				}
			}
		},
		"unpleasant": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"talk": {
							"freq": 1
						}
					}
				}
			}
		},
		"talk": {
			"freq": 1,
			"words": {
				"about": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"afraid": {
			"freq": 2,
			"words": {
				"of": {
					"freq": 1
				},
				"i": {
					"freq": 1,
					"words": {
						"must": {
							"freq": 1
						}
					}
				}
			}
		},
		"sure": {
			"freq": 5,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"your": {
							"freq": 1
						}
					}
				},
				"what's": {
					"freq": 1,
					"words": {
						"wrong": {
							"freq": 1
						}
					}
				}
			}
		},
		"everything": {
			"freq": 3,
			"words": {
				"is": {
					"freq": 2,
					"words": {
						"ready": {
							"freq": 1
						}
					}
				}
			}
		},
		"appreciate": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"help": {
							"freq": 1
						}
					}
				}
			}
		},
		"sounds": {
			"freq": 1,
			"words": {
				"really": {
					"freq": 1,
					"words": {
						"nice": {
							"freq": 1
						}
					}
				}
			}
		},
		"nice": {
			"freq": 2,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"what": {
			"freq": 32,
			"words": {
				"did": {
					"freq": 3,
					"words": {
						"you": {
							"freq": 2
						}
					}
				},
				"time": {
					"freq": 2,
					"words": {
						"do": {
							"freq": 1
						}
					}
				},
				"do": {
					"freq": 4,
					"words": {
						"you": {
							"freq": 2
						}
					}
				},
				"to": {
					"freq": 3,
					"words": {
						"do": {
							"freq": 2
						},
						"eat": {
							"freq": 1
						}
					}
				},
				"he": {
					"freq": 1,
					"words": {
						"does": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 1,
					"words": {
						"mean": {
							"freq": 1
						}
					}
				},
				"she": {
					"freq": 1,
					"words": {
						"meant": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 4,
					"words": {
						"on": {
							"freq": 1
						},
						"it": {
							"freq": 1
						}
					}
				},
				"cities": {
					"freq": 2,
					"words": {
						"did": {
							"freq": 1
						}
					}
				},
				"does": {
					"freq": 1,
					"words": {
						"that": {
							"freq": 1
						}
					}
				},
				"are": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"his": {
			"freq": 9,
			"words": {
				"lack": {
					"freq": 2,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"speech": {
					"freq": 2,
					"words": {
						"inspired": {
							"freq": 1
						}
					}
				},
				"son": {
					"freq": 1,
					"words": {
						"would": {
							"freq": 1
						}
					}
				},
				"mind": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"hand": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				}
			}
		},
		"lack": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"technical": {
							"freq": 1
						}
					}
				}
			}
		},
		"technical": {
			"freq": 1,
			"words": {
				"knowledge": {
					"freq": 1,
					"words": {
						"kept": {
							"freq": 1
						}
					}
				}
			}
		},
		"knowledge": {
			"freq": 1,
			"words": {
				"kept": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"kept": {
			"freq": 2,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				},
				"us": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				}
			}
		},
		"given": {
			"freq": 1,
			"words": {
				"any": {
					"freq": 1,
					"words": {
						"thought": {
							"freq": 1
						}
					}
				}
			}
		},
		"any": {
			"freq": 2,
			"words": {
				"thought": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"party": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"dinner": {
			"freq": 1,
			"words": {
				"with": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				}
			}
		},
		"would": {
			"freq": 22,
			"words": {
				"9": {
					"freq": 2
				},
				"you": {
					"freq": 11,
					"words": {
						"like": {
							"freq": 2
						},
						"mind": {
							"freq": 1
						},
						"give": {
							"freq": 1
						},
						"put": {
							"freq": 1
						},
						"look": {
							"freq": 1
						}
					}
				},
				"study": {
					"freq": 1,
					"words": {
						"harder": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 1,
					"words": {
						"easy": {
							"freq": 1
						}
					}
				},
				"make": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"some": {
			"freq": 7,
			"words": {
				"more": {
					"freq": 1,
					"words": {
						"cake": {
							"freq": 1
						}
					}
				},
				"water": {
					"freq": 1,
					"words": {
						"too": {
							"freq": 1
						}
					}
				},
				"medicine": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				},
				"people": {
					"freq": 2,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"new": {
					"freq": 1,
					"words": {
						"workers": {
							"freq": 1
						}
					}
				}
			}
		},
		"expect": {
			"freq": 2,
			"words": {
				"that": {
					"freq": 1,
					"words": {
						"he": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"worst": {
							"freq": 1
						}
					}
				}
			}
		},
		"man": {
			"freq": 1,
			"words": {
				"robbed": {
					"freq": 1,
					"words": {
						"her": {
							"freq": 1
						}
					}
				}
			}
		},
		"robbed": {
			"freq": 1,
			"words": {
				"her": {
					"freq": 1,
					"words": {
						"bag": {
							"freq": 1
						}
					}
				}
			}
		},
		"very": {
			"freq": 5,
			"words": {
				"surprised": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				},
				"friendly": {
					"freq": 1,
					"words": {
						"people": {
							"freq": 1
						}
					}
				},
				"clearly": {
					"freq": 1
				},
				"glad": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"kind": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"when": {
			"freq": 13,
			"words": {
				"she": {
					"freq": 1,
					"words": {
						"heard": {
							"freq": 1
						}
					}
				},
				"i'm": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				},
				"was": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 2,
					"words": {
						"got": {
							"freq": 1
						},
						"was": {
							"freq": 1
						}
					}
				},
				"we": {
					"freq": 1,
					"words": {
						"saw": {
							"freq": 1
						}
					}
				},
				"does": {
					"freq": 2,
					"words": {
						"school": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"teacher": {
							"freq": 1
						}
					}
				}
			}
		},
		"heard": {
			"freq": 2,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"news": {
							"freq": 1
						}
					}
				},
				"you": {
					"freq": 1,
					"words": {
						"took": {
							"freq": 1
						}
					}
				}
			}
		},
		"watched": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"eat": {
							"freq": 1
						}
					}
				}
			}
		},
		"forced": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"things": {
			"freq": 5,
			"words": {
				"are": {
					"freq": 2,
					"words": {
						"slow": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"enjoy": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"do": {
							"freq": 1
						}
					}
				}
			}
		},
		"slow": {
			"freq": 1,
			"words": {
				"right": {
					"freq": 1,
					"words": {
						"now": {
							"freq": 1
						}
					}
				}
			}
		},
		"mind": {
			"freq": 3,
			"words": {
				"if": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 2,
					"words": {
						"study": {
							"freq": 1
						},
						"be": {
							"freq": 1
						}
					}
				}
			}
		},
		"if": {
			"freq": 4,
			"words": {
				"i": {
					"freq": 2,
					"words": {
						"borrow": {
							"freq": 1
						},
						"can": {
							"freq": 1
						}
					}
				},
				"it's": {
					"freq": 1,
					"words": {
						"possible": {
							"freq": 1
						}
					}
				},
				"she": {
					"freq": 1,
					"words": {
						"didn't": {
							"freq": 1
						}
					}
				}
			}
		},
		"borrow": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"phone": {
							"freq": 1
						}
					}
				}
			}
		},
		"phone": {
			"freq": 1
		},
		"mine's": {
			"freq": 1,
			"words": {
				"out": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"out": {
			"freq": 6,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"batteries": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 2,
					"words": {
						"door": {
							"freq": 1
						},
						"candles": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"how": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"batteries": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"call": {
			"freq": 2,
			"words": {
				"my": {
					"freq": 1,
					"words": {
						"boss": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"tell": {
			"freq": 9,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"about": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 5,
					"words": {
						"what": {
							"freq": 2
						},
						"the": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1,
					"words": {
						"lie": {
							"freq": 1
						}
					}
				}
			}
		},
		"sat": {
			"freq": 1,
			"words": {
				"next": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"next": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"wishing": {
							"freq": 1
						}
					}
				}
			}
		},
		"wishing": {
			"freq": 1,
			"words": {
				"she": {
					"freq": 1,
					"words": {
						"were": {
							"freq": 1
						}
					}
				}
			}
		},
		"let": {
			"freq": 7,
			"words": {
				"me": {
					"freq": 2,
					"words": {
						"hear": {
							"freq": 1
						}
					}
				},
				"go": {
					"freq": 2,
					"words": {
						"of": {
							"freq": 1
						}
					}
				},
				"out": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"hear": {
			"freq": 4,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"frank": {
							"freq": 1
						}
					}
				},
				"from": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"show": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 1
				}
			}
		},
		"want": {
			"freq": 6,
			"words": {
				"to": {
					"freq": 4,
					"words": {
						"see": {
							"freq": 1
						},
						"pick": {
							"freq": 1
						},
						"leave": {
							"freq": 1
						},
						"catch": {
							"freq": 1
						}
					}
				},
				"something": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"she's": {
			"freq": 6,
			"words": {
				"in": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"good": {
					"freq": 2,
					"words": {
						"at": {
							"freq": 1
						}
					}
				}
			}
		},
		"home": {
			"freq": 3,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"at": {
					"freq": 1,
					"words": {
						"about": {
							"freq": 1
						}
					}
				},
				"all": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				}
			}
		},
		"what's": {
			"freq": 7,
			"words": {
				"the": {
					"freq": 4
				},
				"wrong": {
					"freq": 1
				}
			}
		},
		"haven't": {
			"freq": 2,
			"words": {
				"seen": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"faintest": {
							"freq": 1
						}
					}
				}
			}
		},
		"seen": {
			"freq": 2,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"asleep": {
			"freq": 2,
			"words": {
				"while": {
					"freq": 1,
					"words": {
						"listening": {
							"freq": 1
						}
					}
				},
				"before": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				}
			}
		},
		"while": {
			"freq": 3,
			"words": {
				"listening": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"i'm": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				}
			}
		},
		"listening": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"cooking": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"acquainted": {
			"freq": 1,
			"words": {
				"with": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				}
			}
		},
		"something": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"drink": {
							"freq": 1
						}
					}
				}
			}
		},
		"served": {
			"freq": 1,
			"words": {
				"five": {
					"freq": 1,
					"words": {
						"days": {
							"freq": 1
						}
					}
				}
			}
		},
		"five": {
			"freq": 1,
			"words": {
				"days": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				}
			}
		},
		"days": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"jail": {
							"freq": 1
						}
					}
				}
			}
		},
		"jail": {
			"freq": 1,
			"words": {
				"last": {
					"freq": 1,
					"words": {
						"year": {
							"freq": 1
						}
					}
				}
			}
		},
		"last": {
			"freq": 3,
			"words": {
				"year": {
					"freq": 1,
					"words": {
						"after": {
							"freq": 1
						}
					}
				},
				"time": {
					"freq": 1,
					"words": {
						"we": {
							"freq": 1
						}
					}
				},
				"train": {
					"freq": 1
				}
			}
		},
		"year": {
			"freq": 1,
			"words": {
				"after": {
					"freq": 1,
					"words": {
						"pleading": {
							"freq": 1
						}
					}
				}
			}
		},
		"after": {
			"freq": 3,
			"words": {
				"pleading": {
					"freq": 1,
					"words": {
						"guilty": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"luggage": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"place": {
							"freq": 1
						}
					}
				}
			}
		},
		"pleading": {
			"freq": 1,
			"words": {
				"guilty": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"guilty": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"drunken": {
							"freq": 1
						}
					}
				}
			}
		},
		"cooks": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"send": {
			"freq": 2,
			"words": {
				"postcards": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"overnight": {
							"freq": 1
						}
					}
				}
			}
		},
		"postcards": {
			"freq": 1,
			"words": {
				"when": {
					"freq": 1,
					"words": {
						"i'm": {
							"freq": 1
						}
					}
				}
			}
		},
		"aching": {
			"freq": 1,
			"words": {
				"all": {
					"freq": 1,
					"words": {
						"over": {
							"freq": 1
						}
					}
				}
			}
		},
		"one": {
			"freq": 3,
			"words": {
				"more": {
					"freq": 1,
					"words": {
						"blanket": {
							"freq": 1
						}
					}
				},
				"knew": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				},
				"near": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				}
			}
		},
		"castle": {
			"freq": 1,
			"words": {
				"is": {
					"freq": 1,
					"words": {
						"beautiful": {
							"freq": 1
						}
					}
				}
			}
		},
		"sue": {
			"freq": 1,
			"words": {
				"have": {
					"freq": 1,
					"words": {
						"known": {
							"freq": 1
						}
					}
				}
			}
		},
		"known": {
			"freq": 2,
			"words": {
				"each": {
					"freq": 1,
					"words": {
						"other": {
							"freq": 1
						}
					}
				},
				"what": {
					"freq": 1,
					"words": {
						"she": {
							"freq": 1
						}
					}
				}
			}
		},
		"each": {
			"freq": 1,
			"words": {
				"other": {
					"freq": 1,
					"words": {
						"since": {
							"freq": 1
						}
					}
				}
			}
		},
		"other": {
			"freq": 1,
			"words": {
				"since": {
					"freq": 1,
					"words": {
						"1985": {
							"freq": 1
						}
					}
				}
			}
		},
		"audience": {
			"freq": 1,
			"words": {
				"was": {
					"freq": 1,
					"words": {
						"deeply": {
							"freq": 1
						}
					}
				}
			}
		},
		"start": {
			"freq": 2,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"soon": {
							"freq": 1
						}
					}
				},
				"getting": {
					"freq": 1
				}
			}
		},
		"soon": {
			"freq": 1,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				}
			}
		},
		"water": {
			"freq": 2,
			"words": {
				"too": {
					"freq": 1
				}
			}
		},
		"work": {
			"freq": 2,
			"words": {
				"until": {
					"freq": 1,
					"words": {
						"10:00": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"clear": {
							"freq": 1
						}
					}
				}
			}
		},
		"could": {
			"freq": 8,
			"words": {
				"you": {
					"freq": 3,
					"words": {
						"just": {
							"freq": 1
						},
						"tell": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 2,
					"words": {
						"have": {
							"freq": 1
						}
					}
				},
				"swim": {
					"freq": 1,
					"words": {
						"well": {
							"freq": 1
						}
					}
				}
			}
		},
		"walk": {
			"freq": 3,
			"words": {
				"out": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"all": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"away": {
					"freq": 1,
					"words": {
						"from": {
							"freq": 1
						}
					}
				}
			}
		},
		"door": {
			"freq": 1,
			"words": {
				"without": {
					"freq": 1,
					"words": {
						"saying": {
							"freq": 1
						}
					}
				}
			}
		},
		"without": {
			"freq": 1,
			"words": {
				"saying": {
					"freq": 1
				}
			}
		},
		"everybody": {
			"freq": 6,
			"words": {
				"loves": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				},
				"likes": {
					"freq": 2,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"trust": {
			"freq": 1,
			"words": {
				"computer": {
					"freq": 1
				}
			}
		},
		"believe": {
			"freq": 1
		},
		"weren't": {
			"freq": 1,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"impressed": {
							"freq": 1
						}
					}
				}
			}
		},
		"impressed": {
			"freq": 1,
			"words": {
				"as": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"there": {
			"freq": 7,
			"words": {
				"are": {
					"freq": 2,
					"words": {
						"many": {
							"freq": 1
						}
					}
				},
				"one": {
					"freq": 1,
					"words": {
						"near": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 2,
					"words": {
						"an": {
							"freq": 1
						}
					}
				}
			}
		},
		"many": {
			"freq": 4,
			"words": {
				"rats": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				},
				"dog": {
					"freq": 2,
					"words": {
						"owners": {
							"freq": 1
						}
					}
				}
			}
		},
		"rats": {
			"freq": 1,
			"words": {
				"on": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"came": {
			"freq": 3,
			"words": {
				"here": {
					"freq": 1,
					"words": {
						"yesterday": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 2,
					"words": {
						"bus": {
							"freq": 1
						},
						"car": {
							"freq": 1
						}
					}
				}
			}
		},
		"interrupt": {
			"freq": 1,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"while": {
							"freq": 1
						}
					}
				}
			}
		},
		"choice": {
			"freq": 2,
			"words": {
				"but": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"accept": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"offer": {
							"freq": 1
						}
					}
				}
			}
		},
		"denied": {
			"freq": 1,
			"words": {
				"having": {
					"freq": 1,
					"words": {
						"stolen": {
							"freq": 1
						}
					}
				}
			}
		},
		"stolen": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"money": {
							"freq": 1
						}
					}
				}
			}
		},
		"trip": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"san": {
							"freq": 1
						}
					}
				}
			}
		},
		"san": {
			"freq": 1
		},
		"decided": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"give": {
							"freq": 1
						}
					}
				}
			}
		},
		"city": {
			"freq": 1,
			"words": {
				"life": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				}
			}
		},
		"life": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"live": {
							"freq": 1
						}
					}
				}
			}
		},
		"live": {
			"freq": 2,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"within": {
					"freq": 1,
					"words": {
						"200": {
							"freq": 1
						}
					}
				}
			}
		},
		"care": {
			"freq": 4,
			"words": {
				"what": {
					"freq": 2,
					"words": {
						"he": {
							"freq": 1
						},
						"happened": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"wine": {
							"freq": 1
						}
					}
				},
				"of": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"thanks": {
			"freq": 3,
			"words": {
				"a": {
					"freq": 2,
					"words": {
						"lot": {
							"freq": 1
						}
					}
				}
			}
		},
		"go": {
			"freq": 10,
			"words": {
				"straight": {
					"freq": 2,
					"words": {
						"ahead": {
							"freq": 1
						}
					}
				},
				"unless": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 4,
					"words": {
						"any": {
							"freq": 1
						},
						"bed": {
							"freq": 2
						},
						"college": {
							"freq": 1
						}
					}
				},
				"there": {
					"freq": 1,
					"words": {
						"tomorrow": {
							"freq": 1
						}
					}
				},
				"of": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				}
			}
		},
		"loved": {
			"freq": 1,
			"words": {
				"her": {
					"freq": 1,
					"words": {
						"very": {
							"freq": 1
						}
					}
				}
			}
		},
		"her": {
			"freq": 4,
			"words": {
				"very": {
					"freq": 1,
					"words": {
						"much": {
							"freq": 1
						}
					}
				},
				"sister": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"at": {
					"freq": 1,
					"words": {
						"first": {
							"freq": 1
						}
					}
				},
				"dog": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"quite": {
			"freq": 1,
			"words": {
				"dark": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				}
			}
		},
		"dark": {
			"freq": 1,
			"words": {
				"when": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"left": {
			"freq": 2,
			"words": {
				"half": {
					"freq": 1,
					"words": {
						"an": {
							"freq": 1
						}
					}
				},
				"it": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				}
			}
		},
		"half": {
			"freq": 1,
			"words": {
				"an": {
					"freq": 1,
					"words": {
						"hour": {
							"freq": 1
						}
					}
				}
			}
		},
		"an": {
			"freq": 2,
			"words": {
				"hour": {
					"freq": 1,
					"words": {
						"earlier": {
							"freq": 1
						}
					}
				},
				"urgent": {
					"freq": 1,
					"words": {
						"need": {
							"freq": 1
						}
					}
				}
			}
		},
		"must": {
			"freq": 5,
			"words": {
				"buy": {
					"freq": 1,
					"words": {
						"one": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 3,
					"words": {
						"made": {
							"freq": 1
						},
						"known": {
							"freq": 1
						},
						"left": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 1,
					"words": {
						"leaving": {
							"freq": 1
						}
					}
				}
			}
		},
		"you'd": {
			"freq": 3,
			"words": {
				"better": {
					"freq": 2,
					"words": {
						"not": {
							"freq": 1
						}
					}
				}
			}
		},
		"better": {
			"freq": 1,
			"words": {
				"not": {
					"freq": 1,
					"words": {
						"go": {
							"freq": 1
						}
					}
				}
			}
		},
		"down": {
			"freq": 4,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"the": {
					"freq": 1,
					"words": {
						"hill": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1,
					"words": {
						"drinking": {
							"freq": 1
						}
					}
				}
			}
		},
		"please": {
			"freq": 23,
			"words": {
				"look": {
					"freq": 2,
					"words": {
						"after": {
							"freq": 1
						}
					}
				},
				"open": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"shut": {
					"freq": 3,
					"words": {
						"the": {
							"freq": 2
						}
					}
				},
				"show": {
					"freq": 2,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"be": {
					"freq": 2,
					"words": {
						"seated": {
							"freq": 1
						}
					}
				},
				"lend": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"keep": {
					"freq": 2,
					"words": {
						"me": {
							"freq": 1
						}
					}
				}
			}
		},
		"look": {
			"freq": 2,
			"words": {
				"after": {
					"freq": 2,
					"words": {
						"my": {
							"freq": 1
						},
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"along": {
			"freq": 2,
			"words": {
				"with": {
					"freq": 2,
					"words": {
						"your": {
							"freq": 1
						},
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"that's": {
			"freq": 14,
			"words": {
				"right": {
					"freq": 2
				},
				"so": {
					"freq": 2,
					"words": {
						"nice": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 2,
					"words": {
						"schools": {
							"freq": 1
						}
					}
				},
				"too": {
					"freq": 2,
					"words": {
						"many": {
							"freq": 1
						}
					}
				},
				"terrible": {
					"freq": 1
				}
			}
		},
		"made": {
			"freq": 4,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"mistake": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 2,
					"words": {
						"my": {
							"freq": 1
						},
						"his": {
							"freq": 1
						}
					}
				},
				"rapid": {
					"freq": 1,
					"words": {
						"progress": {
							"freq": 1
						}
					}
				}
			}
		},
		"admire": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"courage": {
							"freq": 1
						}
					}
				}
			}
		},
		"baby": {
			"freq": 2,
			"words": {
				"seemed": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 1,
					"words": {
						"fast": {
							"freq": 1
						}
					}
				}
			}
		},
		"seemed": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"be": {
							"freq": 1
						}
					}
				}
			}
		},
		"tony": {
			"freq": 3,
			"words": {
				"runs": {
					"freq": 2,
					"words": {
						"every": {
							"freq": 1
						}
					}
				}
			}
		},
		"runs": {
			"freq": 1,
			"words": {
				"every": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				}
			}
		},
		"unless": {
			"freq": 1,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"want": {
							"freq": 1
						}
					}
				}
			}
		},
		"speech": {
			"freq": 1,
			"words": {
				"inspired": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				}
			}
		},
		"inspired": {
			"freq": 1,
			"words": {
				"all": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"either": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"them": {
							"freq": 1
						}
					}
				}
			}
		},
		"faintest": {
			"freq": 1,
			"words": {
				"idea": {
					"freq": 1,
					"words": {
						"what": {
							"freq": 1
						}
					}
				}
			}
		},
		"idea": {
			"freq": 1,
			"words": {
				"what": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"them": {
			"freq": 3,
			"words": {
				"are": {
					"freq": 1,
					"words": {
						"not": {
							"freq": 1
						}
					}
				},
				"went": {
					"freq": 1,
					"words": {
						"there": {
							"freq": 1
						}
					}
				},
				"up": {
					"freq": 1,
					"words": {
						"or": {
							"freq": 1
						}
					}
				}
			}
		},
		"turn": {
			"freq": 2,
			"words": {
				"right": {
					"freq": 1
				}
			}
		},
		"dog": {
			"freq": 2,
			"words": {
				"owners": {
					"freq": 1,
					"words": {
						"only": {
							"freq": 1
						}
					}
				},
				"a": {
					"freq": 1
				}
			}
		},
		"owners": {
			"freq": 1,
			"words": {
				"only": {
					"freq": 1,
					"words": {
						"feed": {
							"freq": 1
						}
					}
				}
			}
		},
		"only": {
			"freq": 2,
			"words": {
				"feed": {
					"freq": 1,
					"words": {
						"their": {
							"freq": 1
						}
					}
				},
				"about": {
					"freq": 1,
					"words": {
						"5": {
							"freq": 1
						}
					}
				}
			}
		},
		"feed": {
			"freq": 1,
			"words": {
				"their": {
					"freq": 1,
					"words": {
						"dogs": {
							"freq": 1
						}
					}
				}
			}
		},
		"their": {
			"freq": 2,
			"words": {
				"dogs": {
					"freq": 2,
					"words": {
						"once": {
							"freq": 1
						},
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"dogs": {
			"freq": 2,
			"words": {
				"once": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"eat": {
							"freq": 1
						}
					}
				}
			}
		},
		"once": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				}
			}
		},
		"speak": {
			"freq": 1
		},
		"stared": {
			"freq": 1,
			"words": {
				"at": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"hung": {
			"freq": 1,
			"words": {
				"my": {
					"freq": 1,
					"words": {
						"coat": {
							"freq": 1
						}
					}
				}
			}
		},
		"coat": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"wore": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"coat": {
							"freq": 1
						}
					}
				}
			}
		},
		"someone": {
			"freq": 3,
			"words": {
				"must": {
					"freq": 2,
					"words": {
						"have": {
							"freq": 1
						}
					}
				}
			}
		},
		"bottled": {
			"freq": 1,
			"words": {
				"water": {
					"freq": 1
				}
			}
		},
		"juice": {
			"freq": 1
		},
		"let's": {
			"freq": 7,
			"words": {
				"begin": {
					"freq": 3,
					"words": {
						"the": {
							"freq": 1
						},
						"on": {
							"freq": 1
						}
					}
				},
				"split": {
					"freq": 2,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"begin": {
			"freq": 2,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"game": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1,
					"words": {
						"page": {
							"freq": 1
						}
					}
				}
			}
		},
		"finish": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"job": {
							"freq": 1
						}
					}
				}
			}
		},
		"knew": {
			"freq": 2,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"certain": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 1,
					"words": {
						"shouldn't": {
							"freq": 1
						}
					}
				}
			}
		},
		"certain": {
			"freq": 1,
			"words": {
				"how": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"suffering": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"open": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"bottle": {
							"freq": 1
						}
					}
				}
			}
		},
		"show": {
			"freq": 2,
			"words": {
				"last": {
					"freq": 1,
					"words": {
						"night": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 1,
					"words": {
						"another": {
							"freq": 1
						}
					}
				}
			}
		},
		"study": {
			"freq": 1,
			"words": {
				"by": {
					"freq": 1,
					"words": {
						"yourself": {
							"freq": 1
						}
					}
				}
			}
		},
		"cities": {
			"freq": 1,
			"words": {
				"did": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"lost": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"game": {
							"freq": 1
						}
					}
				}
			}
		},
		"introduced": {
			"freq": 1,
			"words": {
				"her": {
					"freq": 1,
					"words": {
						"sister": {
							"freq": 1
						}
					}
				}
			}
		},
		"understand": {
			"freq": 1
		},
		"glass": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"white": {
							"freq": 1
						}
					}
				}
			}
		},
		"lawyer": {
			"freq": 1
		},
		"young": {
			"freq": 1,
			"words": {
				"wishes": {
					"freq": 1,
					"words": {
						"his": {
							"freq": 1
						}
					}
				}
			}
		},
		"wishes": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"son": {
							"freq": 1
						}
					}
				}
			}
		},
		"son": {
			"freq": 1,
			"words": {
				"would": {
					"freq": 1,
					"words": {
						"study": {
							"freq": 1
						}
					}
				}
			}
		},
		"missed": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"last": {
							"freq": 1
						}
					}
				}
			}
		},
		"train": {
			"freq": 2,
			"words": {
				"arrived": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				}
			}
		},
		"clearly": {
			"freq": 1
		},
		"doing": {
			"freq": 3,
			"words": {
				"this": {
					"freq": 2,
					"words": {
						"would": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"homework": {
							"freq": 1
						}
					}
				}
			}
		},
		"easy": {
			"freq": 1
		},
		"been": {
			"freq": 3,
			"words": {
				"working": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				},
				"really": {
					"freq": 1,
					"words": {
						"busy": {
							"freq": 1
						}
					}
				},
				"married": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"working": {
			"freq": 1,
			"words": {
				"all": {
					"freq": 1,
					"words": {
						"day": {
							"freq": 1
						}
					}
				}
			}
		},
		"day": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1
				}
			}
		},
		"crouched": {
			"freq": 1,
			"words": {
				"down": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				}
			}
		},
		"by": {
			"freq": 4,
			"words": {
				"the": {
					"freq": 2,
					"words": {
						"gate": {
							"freq": 1
						},
						"weekend": {
							"freq": 1
						}
					}
				},
				"regular": {
					"freq": 1,
					"words": {
						"mail": {
							"freq": 1
						}
					}
				},
				"him": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"got": {
			"freq": 4,
			"words": {
				"the": {
					"freq": 2,
					"words": {
						"money": {
							"freq": 1
						},
						"ticket": {
							"freq": 1
						}
					}
				},
				"angry": {
					"freq": 1,
					"words": {
						"with": {
							"freq": 1
						}
					}
				},
				"him": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"even": {
			"freq": 2,
			"words": {
				"though": {
					"freq": 1,
					"words": {
						"he": {
							"freq": 1
						}
					}
				},
				"when": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"though": {
			"freq": 1,
			"words": {
				"he": {
					"freq": 1,
					"words": {
						"said": {
							"freq": 1
						}
					}
				}
			}
		},
		"wouldn't": {
			"freq": 1,
			"words": {
				"give": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				}
			}
		},
		"party": {
			"freq": 1,
			"words": {
				"i": {
					"freq": 1,
					"words": {
						"am": {
							"freq": 1
						}
					}
				}
			}
		},
		"am": {
			"freq": 4,
			"words": {
				"invited": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				},
				"i": {
					"freq": 2,
					"words": {
						"making": {
							"freq": 1
						}
					}
				}
			}
		},
		"alarm": {
			"freq": 1,
			"words": {
				"went": {
					"freq": 1,
					"words": {
						"off": {
							"freq": 1
						}
					}
				}
			}
		},
		"felt": {
			"freq": 2,
			"words": {
				"this": {
					"freq": 1,
					"words": {
						"way": {
							"freq": 1
						}
					}
				},
				"relieved": {
					"freq": 1,
					"words": {
						"when": {
							"freq": 1
						}
					}
				}
			}
		},
		"way": {
			"freq": 2,
			"words": {
				"before": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"before": {
			"freq": 2,
			"words": {
				"i": {
					"freq": 1,
					"words": {
						"met": {
							"freq": 1
						}
					}
				},
				"my": {
					"freq": 1,
					"words": {
						"father": {
							"freq": 1
						}
					}
				}
			}
		},
		"found": {
			"freq": 1,
			"words": {
				"it": {
					"freq": 1,
					"words": {
						"difficult": {
							"freq": 1
						}
					}
				}
			}
		},
		"difficult": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"get": {
							"freq": 1
						}
					}
				}
			}
		},
		"ticket": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"nothing": {
							"freq": 1
						}
					}
				}
			}
		},
		"winter": {
			"freq": 1,
			"words": {
				"is": {
					"freq": 1,
					"words": {
						"warm": {
							"freq": 1
						}
					}
				}
			}
		},
		"foot's": {
			"freq": 1,
			"words": {
				"asleep": {
					"freq": 1,
					"words": {
						"again": {
							"freq": 1
						}
					}
				}
			}
		},
		"away": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				}
			}
		},
		"hasn't": {
			"freq": 1,
			"words": {
				"seen": {
					"freq": 1
				}
			}
		},
		"follow": {
			"freq": 3,
			"words": {
				"that": {
					"freq": 2,
					"words": {
						"car": {
							"freq": 1
						}
					}
				}
			}
		},
		"laughed": {
			"freq": 1,
			"words": {
				"at": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				}
			}
		},
		"thank": {
			"freq": 5,
			"words": {
				"you": {
					"freq": 3,
					"words": {
						"so": {
							"freq": 1
						}
					}
				}
			}
		},
		"pick": {
			"freq": 2,
			"words": {
				"them": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				},
				"me": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				}
			}
		},
		"or": {
			"freq": 2,
			"words": {
				"should": {
					"freq": 1,
					"words": {
						"we": {
							"freq": 1
						}
					}
				},
				"by": {
					"freq": 1,
					"words": {
						"regular": {
							"freq": 1
						}
					}
				}
			}
		},
		"kicked": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"hard": {
							"freq": 1
						}
					}
				}
			}
		},
		"postpone": {
			"freq": 1,
			"words": {
				"my": {
					"freq": 1
				}
			}
		},
		"shut": {
			"freq": 3,
			"words": {
				"the": {
					"freq": 2,
					"words": {
						"door": {
							"freq": 2
						}
					}
				},
				"your": {
					"freq": 1,
					"words": {
						"eyes": {
							"freq": 1
						}
					}
				}
			}
		},
		"glad": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"get": {
							"freq": 1
						}
					}
				}
			}
		},
		"present": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"her": {
							"freq": 1
						}
					}
				}
			}
		},
		"likes": {
			"freq": 1,
			"words": {
				"it": {
					"freq": 1,
					"words": {
						"very": {
							"freq": 1
						}
					}
				}
			}
		},
		"enjoy": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"winter": {
							"freq": 1
						}
					}
				}
			}
		},
		"wrong": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"tell": {
							"freq": 1
						}
					}
				}
			}
		},
		"possible": {
			"freq": 1
		},
		"file": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				}
			}
		},
		"nothing": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"do": {
							"freq": 1
						}
					}
				}
			}
		},
		"accustomed": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"mountain": {
							"freq": 1
						}
					}
				}
			}
		},
		"save": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"money": {
							"freq": 1
						}
					}
				}
			}
		},
		"comes": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"bus": {
							"freq": 1
						}
					}
				}
			}
		},
		"aren't": {
			"freq": 1,
			"words": {
				"you": {
					"freq": 1,
					"words": {
						"cold": {
							"freq": 1
						}
					}
				}
			}
		},
		"decision": {
			"freq": 1,
			"words": {
				"was": {
					"freq": 1,
					"words": {
						"put": {
							"freq": 1
						}
					}
				}
			}
		},
		"knows": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"lot": {
							"freq": 1
						}
					}
				}
			}
		},
		"within": {
			"freq": 1,
			"words": {
				"200": {
					"freq": 1,
					"words": {
						"meters": {
							"freq": 1
						}
					}
				}
			}
		},
		"meters": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"spend": {
			"freq": 2,
			"words": {
				"doing": {
					"freq": 1,
					"words": {
						"this": {
							"freq": 1
						}
					}
				},
				"on": {
					"freq": 1
				}
			}
		},
		"less": {
			"freq": 1,
			"words": {
				"time": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"arm": {
			"freq": 1
		},
		"stand": {
			"freq": 1,
			"words": {
				"people": {
					"freq": 1,
					"words": {
						"touching": {
							"freq": 1
						}
					}
				}
			}
		},
		"people": {
			"freq": 3,
			"words": {
				"touching": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"help": {
							"freq": 1
						}
					}
				},
				"have": {
					"freq": 1,
					"words": {
						"trouble": {
							"freq": 1
						}
					}
				}
			}
		},
		"picked": {
			"freq": 1,
			"words": {
				"on": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"beat": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"odds": {
							"freq": 1
						}
					}
				}
			}
		},
		"odds": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"was": {
							"freq": 1
						}
					}
				}
			}
		},
		"injured": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"happy": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"attend": {
							"freq": 1
						}
					}
				}
			}
		},
		"attend": {
			"freq": 1,
			"words": {
				"your": {
					"freq": 1,
					"words": {
						"party": {
							"freq": 1
						}
					}
				}
			}
		},
		"shouldn't": {
			"freq": 1,
			"words": {
				"have": {
					"freq": 1,
					"words": {
						"put": {
							"freq": 1
						}
					}
				}
			}
		},
		"put": {
			"freq": 2,
			"words": {
				"off": {
					"freq": 1,
					"words": {
						"doing": {
							"freq": 1
						}
					}
				},
				"out": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"off": {
			"freq": 1,
			"words": {
				"doing": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				}
			}
		},
		"homework": {
			"freq": 1,
			"words": {
				"until": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"until": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"last": {
							"freq": 1
						}
					}
				}
			}
		},
		"need": {
			"freq": 3,
			"words": {
				"this": {
					"freq": 1,
					"words": {
						"book": {
							"freq": 1
						}
					}
				},
				"to": {
					"freq": 1,
					"words": {
						"prepare": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"people": {
							"freq": 1
						}
					}
				}
			}
		},
		"book": {
			"freq": 1,
			"words": {
				"is": {
					"freq": 1,
					"words": {
						"smaller": {
							"freq": 1
						}
					}
				}
			}
		},
		"chartered": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"bus": {
							"freq": 1
						}
					}
				}
			}
		},
		"dorm's": {
			"freq": 1,
			"words": {
				"heating": {
					"freq": 1,
					"words": {
						"system": {
							"freq": 1
						}
					}
				}
			}
		},
		"heating": {
			"freq": 1,
			"words": {
				"system": {
					"freq": 1,
					"words": {
						"isn't": {
							"freq": 1
						}
					}
				}
			}
		},
		"system": {
			"freq": 1,
			"words": {
				"isn't": {
					"freq": 1,
					"words": {
						"working": {
							"freq": 1
						}
					}
				}
			}
		},
		"little": {
			"freq": 2,
			"words": {
				"better": {
					"freq": 1,
					"words": {
						"now": {
							"freq": 1
						}
					}
				}
			}
		},
		"medicine": {
			"freq": 1,
			"words": {
				"this": {
					"freq": 1,
					"words": {
						"morning": {
							"freq": 1
						}
					}
				}
			}
		},
		"morning": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"overnight": {
			"freq": 1,
			"words": {
				"or": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				}
			}
		},
		"schools": {
			"freq": 1,
			"words": {
				"closed": {
					"freq": 1,
					"words": {
						"early": {
							"freq": 1
						}
					}
				}
			}
		},
		"college": {
			"freq": 1,
			"words": {
				"has": {
					"freq": 1
				}
			}
		},
		"according": {
			"freq": 3,
			"words": {
				"to": {
					"freq": 2
				}
			}
		},
		"bought": {
			"freq": 2,
			"words": {
				"a": {
					"freq": 2,
					"words": {
						"new": {
							"freq": 1
						},
						"skirt": {
							"freq": 1
						}
					}
				}
			}
		},
		"wonder": {
			"freq": 1,
			"words": {
				"who": {
					"freq": 1,
					"words": {
						"started": {
							"freq": 1
						}
					}
				}
			}
		},
		"started": {
			"freq": 1,
			"words": {
				"that": {
					"freq": 1,
					"words": {
						"rumor": {
							"freq": 1
						}
					}
				}
			}
		},
		"looking": {
			"freq": 2,
			"words": {
				"for": {
					"freq": 2,
					"words": {
						"a": {
							"freq": 2
						}
					}
				}
			}
		},
		"father": {
			"freq": 2,
			"words": {
				"came": {
					"freq": 1,
					"words": {
						"home": {
							"freq": 1
						}
					}
				},
				"is": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"prepare": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"formal": {
							"freq": 1
						}
					}
				}
			}
		},
		"relieved": {
			"freq": 1,
			"words": {
				"when": {
					"freq": 1,
					"words": {
						"we": {
							"freq": 1
						}
					}
				}
			}
		},
		"saw": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"light": {
							"freq": 1
						}
					}
				}
			}
		},
		"light": {
			"freq": 4,
			"words": {
				"in": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"travels": {
					"freq": 2,
					"words": {
						"faster": {
							"freq": 1
						}
					}
				}
			}
		},
		"anything": {
			"freq": 2,
			"words": {
				"else": {
					"freq": 1
				}
			}
		},
		"angry": {
			"freq": 1,
			"words": {
				"with": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"high": {
			"freq": 1,
			"words": {
				"school": {
					"freq": 1,
					"words": {
						"students": {
							"freq": 1
						}
					}
				}
			}
		},
		"asked": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"where": {
							"freq": 1
						}
					}
				}
			}
		},
		"snowed": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"lot": {
							"freq": 1
						}
					}
				}
			}
		},
		"excuse": {
			"freq": 2,
			"words": {
				"me": {
					"freq": 1
				}
			}
		},
		"accepted": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"job": {
							"freq": 1
						}
					}
				}
			}
		},
		"hates": {
			"freq": 1,
			"words": {
				"fish": {
					"freq": 1,
					"words": {
						"and": {
							"freq": 1
						}
					}
				}
			}
		},
		"fish": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"never": {
							"freq": 1
						}
					}
				}
			}
		},
		"arrived": {
			"freq": 1,
			"words": {
				"on": {
					"freq": 1,
					"words": {
						"time": {
							"freq": 1
						}
					}
				}
			}
		},
		"endure": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"long": {
							"freq": 1
						}
					}
				}
			}
		},
		"intended": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"go": {
							"freq": 1
						}
					}
				}
			}
		},
		"quiet": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"prime": {
			"freq": 1,
			"words": {
				"minister": {
					"freq": 1,
					"words": {
						"will": {
							"freq": 1
						}
					}
				}
			}
		},
		"minister": {
			"freq": 1,
			"words": {
				"will": {
					"freq": 1,
					"words": {
						"hold": {
							"freq": 1
						}
					}
				}
			}
		},
		"hold": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"press": {
							"freq": 1
						}
					}
				}
			}
		},
		"press": {
			"freq": 1,
			"words": {
				"conference": {
					"freq": 1,
					"words": {
						"tomorrow": {
							"freq": 1
						}
					}
				}
			}
		},
		"good": {
			"freq": 6,
			"words": {
				"choice": {
					"freq": 1
				},
				"president": {
					"freq": 1,
					"words": {
						"also": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 2,
					"words": {
						"you": {
							"freq": 1
						}
					}
				},
				"at": {
					"freq": 1,
					"words": {
						"tennis": {
							"freq": 1
						}
					}
				}
			}
		},
		"make": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"good": {
							"freq": 1
						}
					}
				}
			}
		},
		"passengers": {
			"freq": 1,
			"words": {
				"were": {
					"freq": 1,
					"words": {
						"saved": {
							"freq": 1
						}
					}
				}
			}
		},
		"saved": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"drowning": {
							"freq": 1
						}
					}
				}
			}
		},
		"yesterday": {
			"freq": 3
		},
		"stayed": {
			"freq": 1,
			"words": {
				"home": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				}
			}
		},
		"school's": {
			"freq": 1,
			"words": {
				"closed": {
					"freq": 1,
					"words": {
						"early": {
							"freq": 1
						}
					}
				}
			}
		},
		"school": {
			"freq": 1,
			"words": {
				"let": {
					"freq": 1,
					"words": {
						"out": {
							"freq": 1
						}
					}
				}
			}
		},
		"carried": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"heavy": {
							"freq": 1
						}
					}
				}
			}
		},
		"heavy": {
			"freq": 2,
			"words": {
				"bag": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				},
				"snowstorm": {
					"freq": 1,
					"words": {
						"kept": {
							"freq": 1
						}
					}
				}
			}
		},
		"bag": {
			"freq": 1,
			"words": {
				"on": {
					"freq": 1,
					"words": {
						"my": {
							"freq": 1
						}
					}
				}
			}
		},
		"snowstorm": {
			"freq": 1,
			"words": {
				"kept": {
					"freq": 1,
					"words": {
						"us": {
							"freq": 1
						}
					}
				}
			}
		},
		"us": {
			"freq": 1,
			"words": {
				"from": {
					"freq": 1,
					"words": {
						"going": {
							"freq": 1
						}
					}
				}
			}
		},
		"didn't": {
			"freq": 1,
			"words": {
				"care": {
					"freq": 1,
					"words": {
						"what": {
							"freq": 1
						}
					}
				}
			}
		},
		"dinner's": {
			"freq": 2,
			"words": {
				"ready": {
					"freq": 1
				}
			}
		},
		"told": {
			"freq": 1,
			"words": {
				"anyone": {
					"freq": 1,
					"words": {
						"about": {
							"freq": 1
						}
					}
				}
			}
		},
		"anyone": {
			"freq": 2,
			"words": {
				"about": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				},
				"else": {
					"freq": 1,
					"words": {
						"coming": {
							"freq": 1
						}
					}
				}
			}
		},
		"lived": {
			"freq": 1,
			"words": {
				"overseas": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"overseas": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"ten": {
							"freq": 1
						}
					}
				}
			}
		},
		"those": {
			"freq": 3,
			"words": {
				"glasses": {
					"freq": 2,
					"words": {
						"suit": {
							"freq": 1
						}
					}
				}
			}
		},
		"glasses": {
			"freq": 1,
			"words": {
				"suit": {
					"freq": 1,
					"words": {
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"gold": {
			"freq": 3,
			"words": {
				"is": {
					"freq": 2,
					"words": {
						"heavier": {
							"freq": 1
						}
					}
				}
			}
		},
		"heavier": {
			"freq": 1,
			"words": {
				"than": {
					"freq": 1,
					"words": {
						"silver": {
							"freq": 1
						}
					}
				}
			}
		},
		"repair": {
			"freq": 1,
			"words": {
				"my": {
					"freq": 1,
					"words": {
						"car": {
							"freq": 1
						}
					}
				}
			}
		},
		"feeds": {
			"freq": 1,
			"words": {
				"her": {
					"freq": 1,
					"words": {
						"dog": {
							"freq": 1
						}
					}
				}
			}
		},
		"against": {
			"freq": 1,
			"words": {
				"doing": {
					"freq": 1,
					"words": {
						"it": {
							"freq": 1
						}
					}
				}
			}
		},
		"friends": {
			"freq": 1,
			"words": {
				"like": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"same": {
			"freq": 1,
			"words": {
				"kind": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"kind": {
			"freq": 2,
			"words": {
				"of": {
					"freq": 2,
					"words": {
						"music": {
							"freq": 1
						},
						"you": {
							"freq": 1
						}
					}
				}
			}
		},
		"music": {
			"freq": 1,
			"words": {
				"that": {
					"freq": 1,
					"words": {
						"i": {
							"freq": 1
						}
					}
				}
			}
		},
		"bit": {
			"freq": 1,
			"words": {
				"short": {
					"freq": 1,
					"words": {
						"of": {
							"freq": 1
						}
					}
				}
			}
		},
		"short": {
			"freq": 1,
			"words": {
				"of": {
					"freq": 1,
					"words": {
						"money": {
							"freq": 1
						}
					}
				}
			}
		},
		"bank": {
			"freq": 1
		},
		"married": {
			"freq": 2,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"nancy": {
							"freq": 1
						}
					}
				},
				"for": {
					"freq": 1,
					"words": {
						"more": {
							"freq": 1
						}
					}
				}
			}
		},
		"nancy": {
			"freq": 1,
			"words": {
				"next": {
					"freq": 1,
					"words": {
						"week": {
							"freq": 1
						}
					}
				}
			}
		},
		"bed": {
			"freq": 2,
			"words": {
				"at": {
					"freq": 2,
					"words": {
						"eleven": {
							"freq": 2
						}
					}
				}
			}
		},
		"urgent": {
			"freq": 1,
			"words": {
				"need": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"help": {
			"freq": 1,
			"words": {
				"clean": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				}
			}
		},
		"clean": {
			"freq": 1,
			"words": {
				"up": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"trouble": {
			"freq": 1,
			"words": {
				"getting": {
					"freq": 1,
					"words": {
						"their": {
							"freq": 1
						}
					}
				}
			}
		},
		"getting": {
			"freq": 2,
			"words": {
				"their": {
					"freq": 1,
					"words": {
						"dogs": {
							"freq": 1
						}
					}
				}
			}
		},
		"eat": {
			"freq": 1,
			"words": {
				"dog": {
					"freq": 1,
					"words": {
						"food": {
							"freq": 1
						}
					}
				}
			}
		},
		"boiled": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"eggs": {
							"freq": 1
						}
					}
				}
			}
		},
		"leaving": {
			"freq": 1
		},
		"men": {
			"freq": 1,
			"words": {
				"like": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"figure": {
			"freq": 1,
			"words": {
				"out": {
					"freq": 1,
					"words": {
						"how": {
							"freq": 1
						}
					}
				}
			}
		},
		"upload": {
			"freq": 1,
			"words": {
				"an": {
					"freq": 1,
					"words": {
						"image": {
							"freq": 1
						}
					}
				}
			}
		},
		"yes": {
			"freq": 3
		},
		"busy": {
			"freq": 1,
			"words": {
				"here": {
					"freq": 1,
					"words": {
						"all": {
							"freq": 1
						}
					}
				}
			}
		},
		"leave": {
			"freq": 1,
			"words": {
				"it": {
					"freq": 1,
					"words": {
						"up": {
							"freq": 1
						}
					}
				}
			}
		},
		"lend": {
			"freq": 1,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"set": {
			"freq": 1,
			"words": {
				"out": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				}
			}
		},
		"keep": {
			"freq": 1,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"informed": {
							"freq": 1
						}
					}
				}
			}
		},
		"helped": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"tie": {
							"freq": 1
						}
					}
				}
			}
		},
		"tie": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"tie": {
							"freq": 1
						}
					}
				}
			}
		},
		"hired": {
			"freq": 1,
			"words": {
				"some": {
					"freq": 1,
					"words": {
						"new": {
							"freq": 1
						}
					}
				}
			}
		},
		"saving": {
			"freq": 1,
			"words": {
				"up": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"swim": {
			"freq": 1,
			"words": {
				"well": {
					"freq": 1,
					"words": {
						"even": {
							"freq": 1
						}
					}
				}
			}
		},
		"travels": {
			"freq": 1,
			"words": {
				"faster": {
					"freq": 1,
					"words": {
						"than": {
							"freq": 1
						}
					}
				}
			}
		},
		"faster": {
			"freq": 1,
			"words": {
				"than": {
					"freq": 1,
					"words": {
						"sound": {
							"freq": 1
						}
					}
				}
			}
		},
		"raced": {
			"freq": 1,
			"words": {
				"him": {
					"freq": 1,
					"words": {
						"down": {
							"freq": 1
						}
					}
				}
			}
		},
		"catch": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"11:45": {
							"freq": 1
						}
					}
				}
			}
		},
		"big": {
			"freq": 1,
			"words": {
				"change": {
					"freq": 1,
					"words": {
						"for": {
							"freq": 1
						}
					}
				}
			}
		},
		"change": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"me": {
							"freq": 1
						}
					}
				}
			}
		},
		"usually": {
			"freq": 1,
			"words": {
				"decide": {
					"freq": 1,
					"words": {
						"what": {
							"freq": 1
						}
					}
				}
			}
		},
		"decide": {
			"freq": 1,
			"words": {
				"what": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"house": {
			"freq": 1,
			"words": {
				"has": {
					"freq": 1,
					"words": {
						"six": {
							"freq": 1
						}
					}
				}
			}
		},
		"clear": {
			"freq": 1,
			"words": {
				"up": {
					"freq": 1,
					"words": {
						"by": {
							"freq": 1
						}
					}
				}
			}
		},
		"running": {
			"freq": 1,
			"words": {
				"to": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"doctor": {
			"freq": 1,
			"words": {
				"advised": {
					"freq": 1,
					"words": {
						"him": {
							"freq": 1
						}
					}
				}
			}
		},
		"cut": {
			"freq": 1,
			"words": {
				"down": {
					"freq": 1,
					"words": {
						"on": {
							"freq": 1
						}
					}
				}
			}
		},
		"broke": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"rule": {
							"freq": 1
						}
					}
				}
			}
		},
		"gifts": {
			"freq": 1,
			"words": {
				"for": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"teased": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"new": {
							"freq": 1
						}
					}
				}
			}
		},
		"skirt": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"there's": {
			"freq": 3,
			"words": {
				"a": {
					"freq": 2,
					"words": {
						"restaurant": {
							"freq": 1
						}
					}
				}
			}
		},
		"restaurant": {
			"freq": 1,
			"words": {
				"near": {
					"freq": 1,
					"words": {
						"here": {
							"freq": 1
						}
					}
				}
			}
		},
		"concert": {
			"freq": 1,
			"words": {
				"was": {
					"freq": 1,
					"words": {
						"a": {
							"freq": 1
						}
					}
				}
			}
		},
		"raised": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"hand": {
							"freq": 1
						}
					}
				}
			}
		},
		"hand": {
			"freq": 1,
			"words": {
				"when": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"teacher": {
			"freq": 1,
			"words": {
				"finished": {
					"freq": 1,
					"words": {
						"the": {
							"freq": 1
						}
					}
				}
			}
		},
		"finished": {
			"freq": 2,
			"words": {
				"the": {
					"freq": 2,
					"words": {
						"reading": {
							"freq": 1
						},
						"beer": {
							"freq": 1
						}
					}
				}
			}
		},
		"split": {
			"freq": 1,
			"words": {
				"the": {
					"freq": 1,
					"words": {
						"bill": {
							"freq": 1
						}
					}
				}
			}
		},
		"beer": {
			"freq": 1,
			"words": {
				"and": {
					"freq": 1,
					"words": {
						"ordered": {
							"freq": 1
						}
					}
				}
			}
		},
		"invite": {
			"freq": 1,
			"words": {
				"me": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"making": {
			"freq": 1,
			"words": {
				"myself": {
					"freq": 1,
					"words": {
						"clear": {
							"freq": 1
						}
					}
				}
			}
		},
		"remember": {
			"freq": 1,
			"words": {
				"how": {
					"freq": 1,
					"words": {
						"to": {
							"freq": 1
						}
					}
				}
			}
		},
		"achieved": {
			"freq": 1,
			"words": {
				"his": {
					"freq": 1,
					"words": {
						"goal": {
							"freq": 1
						}
					}
				}
			}
		},
		"consult": {
			"freq": 1,
			"words": {
				"a": {
					"freq": 1,
					"words": {
						"lawyer": {
							"freq": 1
						}
					}
				}
			}
		},
		"which": {
			"freq": 2,
			"words": {
				"one": {
					"freq": 1
				}
			}
		},
		"place": {
			"freq": 1,
			"words": {
				"while": {
					"freq": 1,
					"words": {
						"i'm": {
							"freq": 1
						}
					}
				}
			}
		},
		"rapid": {
			"freq": 1,
			"words": {
				"progress": {
					"freq": 1,
					"words": {
						"in": {
							"freq": 1
						}
					}
				}
			}
		},
		"progress": {
			"freq": 1,
			"words": {
				"in": {
					"freq": 1
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/default-predictive-words.json
// module id = 951
// module chunks = 1